import Select from 'react-select'
import React, { useEffect, useRef, useState } from 'react'
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CNav,
  CNavItem,
  CButton,
  CNavLink,
  CFormTextarea,
  CSpinner,
  CAvatar,
  CImage,
  CAccordion,
  CAccordionBody,
  CAccordionItem,
  CAccordionHeader,
  CFormLabel,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormCheck,
  CBreadcrumbItem,
  CBreadcrumb,
} from '@coreui/react'
import PatientPersonalHistory from './PatientPersonalHistory'
import PatientInfoDisplay from './PatientInfoDisplay'
import PatientVitals from './PatientVitals'
import PatientMedication from './PatientMedication'
import PatientImaging from './PatientImaging'
import ShowDemographics from './Demographics'

import PatientHistoryForm from './PatientHistoryForm'
import PatientInternalNotes from './PatientInternalNotes'
import Addendum from './Addendum'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api'

import DiagnosisAssessment from './DiagnosisAssessment'
import PatientAllergies from './PatientAllergies'
import PatientFinalNote from './PatientFinalNote'
import PatientLabs from './PatientLabs'
import Summary from './Summary'
import { useDispatch, useSelector } from 'react-redux'
import Note from './Note'
import PatientMedications from '../../services/general/patientMedicationData.api'
import PatientImagingsCRUD from '../../services/general/patientImagingData'
import ImagingInformation from '../../services/general/ImagingAPI.api'
import ModifyPatientHistory from '../../services/general/modifyPatientHistory.api'
import fetchPatientData from '../../services/general/patientGeneralAPI.api'
import GetPatientAllergiesCRUD from '../../services/general/getPatientAllergies.api'
import PatientLabsCRUD from '../../services/general/patientLabsCrud.api'
import PatientOrder from './PatientOrder'
import PatientOrdersCRUD from '../../services/general/patientOrders.api'
// import ViewCallCenter from './ViewCallCenter';
import MedicineCRUD from '../../services/general/Medication.api'
import { TuneOutlined } from '@mui/icons-material'
import { motion } from 'framer-motion'
import { Check, CheckCircle, EllipsisVertical, Pencil, Printer, Save } from 'lucide-react'
import PatientDataCRUD from '../../services/general/patientNoteData.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import { usePDF } from 'react-to-pdf'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Reports from './Reports'
import Loader from '../../components/shared/Loader'
import HPIQuestions from './HPIQuestions'
import Provider from './Provider'
import DetailNote from './DetailNote'
import SuperBill from './SuperBill'
import { Data } from '@react-google-maps/api'
import AddDiagnosisModal from './AddDiagnosisModal'
import PatientNoteViewInModal from './PatientNoteViewInModal'
import PastOrder from './PastOrder'
import SaveExtra from '../../services/general/saveExtraData.api'
import PatientPastNote from './PatientPastNote'
import FacilityCRUD from '../../services/general/getFacilityData.api'
import ProviderFinalNote from './ProviderFinalNote'
import ProviderPatientMedication from './ProviderPatientMedication'
import PatientProviderlabs from './PatientProviderlabs'
import ProvuderPatientImaging from './ProviderPatientImaging'
import ProviderPoac from './ProviderPoac'
import ProviderPatientHistory from './ProviderPatientHistory'
import ProviderEducation from './ProviderEducation'
import ProviderSuperbill from './ProviderSuperbill'
import ProviderOrder from './ProviderOrder'
import ProviderPatientTreatmentShell from './ProviderPatientTreatmentShell'
import ProviderNotesBont from './ProviderNotesBont'
import ProviderAddendum from './ProviderAddendum'
import ShowOrders from '../../components/shared/showOrders'
import ShowAddedOrders from './ShowAddedOrders'
import getPatientPersonalHistory from '../../services/general/getPatientHistory.api'
import PatientAppointmentDetails from '../../services/general/appointmentData.api'
import PatientSuperBillData from '../../services/general/patientSuperBill.api'
import ProviderPatientFloatingButton from './ProviderPatientFloatingButton'
import ProviderHR from './ProviderHR'
import ProviderIncidentTabTest from './ProviderIncidentTabTest'
import ProviderRosTabTest from './ProviderRosTabTest'
import { getAllAppointments, getAllAppointmentsDetails, getAppointmentDataID } from '../../components/shared/appointmentFilterData'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api.js'
import SavePatients from '../../services/general/savePatientinformation.api'
import { useSidebar } from '../../components/SidebarContext'
import FloatingNotePreview from './FloatingNotePreview'
import AddProviderPatientForm from '../../components/shared/AppProviderPatientForm'
import { CircularProgress } from '@mui/material'
import ProviderPastOrder from './ProviderPastOrder'
import { useIndexedDB } from '../../context/IndexedContext'
import ProviderPatientNoteViewInModal from './ProviderPatientNoteViewInModal'
import ProviderLsSuperBillComponent from './ProviderLsSuperBillComponent'
import ProviderLsPatientNoteViewTest from './ProviderLsPatientNoteViewTest'
import ProviderNotesBontTest from './ProviderNotesBontTest'
import ProviderPatientHistoryTest from './ProviderPatientHistoryTest'
import ProviderObjectivedatatest from './ProviderObjectiveDataTest'
import ProviderHpiTabTest from './ProviderHpiTabTest'
import ProviderPhysicalExaminationTabTest from './ProviderPhysicalExaminationTabTest'
import ProviderPatientTreatmentShellTest from './ProviderPatientTreatmentShellTest'
import ProviderOrderTest from './ProviderOrderTest'
import ProviderPatientFloatingButtonTest from './ProviderPatientFloatingButtonTest'
import FloatingNotePreviewTest from './FloatingNotePreviewTest'

const PatientInfoTodaysAppointmentsTest = ({
  creatingNewNote = false,
  peAdded,
  setPEAdded,
  hpiAdded,
  rosAdded,
  setRosAdded,
  setHpiAdded,
  setCreatingNewNote,
  allAppointmentRawData,
  addedNewIncident,
  setAddedNewIncident,
  //   patientID,
  //   patientData,
  //   dataCallType,
  //   setDataId,
  //   noteID,
  //   setEditDataId,
  //   setDataCallType,
  //   noteStatus,
  showAllData = true,
  showNoteView = false,
  // appointments,
  //   handleAddNoteId,
  isAllotedToProvider = false,
}) => {
  const [activeTab, setActiveTab] = useState(21)
  const [addDiagnosisModalVisible, setAddDiagnosisModalVisible] = useState(false)
  const [historyPersonalHistoryActiveTab, setHistoryPersonalHistoryActiveTab] = useState('pmhx')
  const [loading, setLoading] = useState(false)
  const [diagnosisData, setDiagnosisData] = useState([])
  const [patientDiagnosis, setPatientDiagnosis] = useState([])
  const [allergiesList, setAllergiesList] = useState([])
  const [Notes, setNotes] = useState([])
  const [vitalsList, setVitalsList] = useState([])
  const [diagnosisAddedPinger, setDiagnosisAddedPinger] = useState(false)
  const [allHistory, setAllHistory] = useState([])
  const [allLabs, setAllLabs] = useState([])
  const [reRender, setReRender] = useState(false)
  const [patientOrders, setPatientOrders] = useState([])
  const [masterMedications, setMasterMedications] = useState([])
  const [newImagingAdded, setNewImagingAdded] = useState(false)
  const [newmedsAdded, setNewmedsAdded] = useState(false)
  const [newLabsAdded, setNewLabsAdded] = useState(false)
  const [isPatientPageLoading, setIsPatientPageLoading] = useState(false)
  const [selectedRisks, setSelectedRisks] = useState({})
  const [selectedDifferentialDiagnosis, setSelectedDifferentialDiagnosis] = useState({})
  const [MasterDiagnosisData, setMasterDiagnosisData] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [showComment, setShowComment] = useState(false)
  const [showSaveModel, setShowSaveModel] = useState(false)
  const [histories, setHistories] = useState({
    pmhx: [],
    pshx: [],
    fh: [],
    sh: [],
  })
  const {
    getAllMasterDiagnosis,
    getImagingInformationData,
    getTestOfflineData,
    getProviderList,
    getProviderDetails,
    saveTestOfflineData,
    getAllAppointmentData,
    getMedicationMasterData,
    getMedicationinformationData,
    getAllTodaysAppointment,
    saveAllTodaysAppointment,
    getPatientDetails,
    getAllAppointmentDetails,
    savePatientDetails,
  } = useIndexedDB()
  const { isSidebarOpen, toggleSidebar, closeSidebar, openSidebar } = useSidebar()
  const [patientTreatments, setPatientTreatments] = useState([])
  const [diagnosisCode, setDiagnosisCodes] = useState({})
  const [noteView, setNoteView] = useState(false)
  const [signModel, setSignModel] = useState(false)
  const [appoinmentDate, setAppointmentData] = useState()
  const [selectedFacility, setSelectedFacility] = useState({})
  const [facilities, setFacilities] = useState([])
  const [showOrderPopUp, setShowOrderPopUp] = useState(true)
  const [addendum, setAddendum] = useState([])
  const [pastOrders, setPastOrders] = useState([])
  const [currentOrder, setCurrentOrder] = useState([])
  const [showOrderPopUpYN, setShowOrderPopUpYN] = useState(false)
  const [isAckChecked, setIsAckChecked] = useState(false)
  const [showSuperBill, setShowSuperBill] = useState(false)
  const [allOrders, setAllOrders] = useState([])
  const [togglePoacFreetype, setTogglePoacFreetype] = useState(false)

  //   parent states and functions

  const [patientIDClicked, setPatientIDClicked] = useState(-1)
  const [rowClicked, setRowClicked] = useState(null)
  const [patientID, setPatientID] = useState(-1)
  const [patientData, setPatientData] = useState({})
  const [dataCallType, setDataCallType] = useState(null)
  const [setDataId, setEditDataId] = useState(null)
  const [noteID, setNoteID] = useState(null)
  const [addedInsurances, setAddedInsurances] = useState([])
  const [noteStatus, setNoteStatus] = useState('New Note')
  const [appointment, setAppointment] = useState([])
  const [appointmentPatient, setAppointmentPatient] = useState(null)
  const [appointments, setAppointments] = useState([])
  const [patientAppointmentID, setPatientAppointmentID] = useState(null)
  const [loggedUserProvider, setLoggedUserProvider] = useState({})
  const [patientDBData, setPatientDBData] = useState({})

  const [changesInTreatmentShell, setChangesInTreatmentShell] = useState(false)

  const getProvidersMaster = async () => {
    // setIsPageLoading(true)
    try {
      // Fetch provider data

      const getProviderDetailsData = await getProviderDetails()

      const data = await getTestOfflineData()
      const DBData = data[getProviderDetailsData?.ID] || []
      const patientWiseDBdata = DBData[patientID] || {}
      setPatientDBData(patientWiseDBdata)

      setLoggedUserProvider(getProviderDetailsData || {})
      // let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
      // providerData = JSON.parse(providerData.d)?.Data
      // const getUser = JSON.parse(localStorage.getItem('user'))

      // const foundProvider = providerData.find((obj) => obj.UserId === getUser?.Username)
      // setLoggedUserProvider(foundProvider || {})
    } catch (error) {
      console.log(error)
    } finally {
      // setIsPageLoading(false)
    }
  }

  useEffect(() => {
    getProvidersMaster()
  }, [patientID])

  const getLoggedProviderId = () => {
    const provider = JSON.parse(localStorage.getItem('loggedUserProviderId'))
    return provider || null
  }

  const safeParser = (data) => {
    try {
      return JSON.parse(data)
    } catch (e) {
      return data
    }
  }

  useEffect(() => {
    const fetchAppointmentData = async () => {
      const getAppointmentData = await getAllAppointmentsDetails('GET')
      setAppointments(getAppointmentData)
    }
    fetchAppointmentData()
  }, [])

  useEffect(() => {
    const setPatientIDLocal = safeParser(localStorage.getItem('setPatientIDLocal'))
    const setPatientIDClickedLocal = safeParser(localStorage.getItem('setPatientIDClickedLocal'))
    const setRowClickedLocal = safeParser(localStorage.getItem('setRowClickedLocal'))
    const setPatientModalVisibleLocal = safeParser(localStorage.getItem('setPatientModalVisibleLocal'))
    const setPatientAppointmentIDLocal = safeParser(localStorage.getItem('setPatientAppointmentIDLocal'))
    const editDataIdLocal = safeParser(localStorage.getItem('editDataIdLocal'))
    const dataCallTypeLocal = safeParser(localStorage.getItem('dataCallTypeLocal'))
    const noteStatusLocal = safeParser(localStorage.getItem('noteStatusLocal'))
    const patientModalVisibleLocal = safeParser(localStorage.getItem('patientModalVisibleLocal'))
    const noteIDLocal = safeParser(localStorage.getItem('noteIDLocal'))
    const patientDataLocal = safeParser(localStorage.getItem('patientDataLocal'))
    const noteStructureRefLocal = safeParser(localStorage.getItem('noteStructureRefLocal'))

    if (setPatientIDLocal && setPatientIDLocal !== -1) {
      setPatientID(setPatientIDLocal)
    }
    if (setPatientIDClickedLocal && setPatientIDClickedLocal !== -1) {
      setPatientIDClicked(setPatientIDClickedLocal)
    }
    if (setRowClickedLocal !== null && setRowClickedLocal !== undefined) {
      setRowClicked(setRowClickedLocal)
      setPatientData(setRowClickedLocal)
    }
    if (setPatientModalVisibleLocal) {
      //   set(setPatientModalVisibleLocal)
    }
    if (setPatientAppointmentIDLocal) {
      setPatientAppointmentID(setPatientAppointmentIDLocal)
    }
    if (editDataIdLocal) {
      setEditDataId(editDataIdLocal)
    }
    if (dataCallTypeLocal) {
      setDataCallType(dataCallTypeLocal)
    }
    if (noteStatusLocal) {
      setNoteStatus(noteStatusLocal)
    }
    if (patientModalVisibleLocal) {
      // setPatientModalVisible(patientModalVisibleLocal)
    }
    if (noteIDLocal !== null && noteIDLocal !== undefined) {
      setNoteID(noteIDLocal)
    }
    if (patientDataLocal) {
      setPatientData(patientDataLocal)
    }
    if (noteStructureRefLocal !== null && noteStructureRefLocal !== undefined) {
      // noteStructureRef.current = noteStructureRefLocal
      closeSidebar()
    }

    localStorage.removeItem('setPatientIDLocal')
    localStorage.removeItem('setPatientIDClickedLocal')
    localStorage.removeItem('setRowClickedLocal')
    localStorage.removeItem('setPatientModalVisibleLocal')
    localStorage.removeItem('setPatientAppointmentIDLocal')
    localStorage.removeItem('editDataIdLocal')
    localStorage.removeItem('dataCallTypeLocal')
    localStorage.removeItem('noteStatusLocal')
    localStorage.removeItem('patientModalVisibleLocal')
    localStorage.removeItem('noteIDLocal')
    localStorage.removeItem('patientDataLocal')
    localStorage.removeItem('noteStructureRefLocal')
  }, [])

  const [childformData, setChildFormData] = useState({
    FirstName: '',
    MiddleName: '',
    LastName: '',
    DOB: '',
    Gender: '',
    Age: '0',
    PhoneNumber: '',
    EmergencyName: '',
    EmergencyPhone: '',
    Address: '',
    State: '',
    City: '',
    ZipCode: '',
    Country: '',
    insurance: '',
    Status: 'NewPatient',
  })

  const resetStates = () => {
    setChildFormData({
      FirstName: '',
      MiddleName: '',
      LastName: '',
      DOB: '',
      Gender: '',
      Age: '0',
      PhoneNumber: '',
      EmergencyName: '',
      EmergencyPhone: '',
      Address: '',
      State: '',
      City: '',
      ZipCode: '',
      Country: '',
      insurance: '',
      Status: 'NewPatient',
    })
    // setRoomNumber('')
    setSelectedFacility({})
    setAddedInsurances([])
    // setInsuranceList([])
    // setSelectedDetails({})
    // setAllSelectedDiagnosis([])
    // setModalVisible(false)
    setEditModalVisible(false)
    // setPatientID('')
  }

  const handleAddNoteId = async (noteID) => {
    try {
      // setIsPageLoading(true)

      const groupedData = []
      let appointmentFilterData = appointments.map((item) => {
        if (item.data.AppointmentID === patientAppointmentID) {
          return {
            ...item,
            data: {
              ...item.data,
              NoteID: noteID,
            },
          }
        }
        return item
      })

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      // getAppointmentData()
      patientDataFn()

      // toast.success('Cancel Appointment Successfully', toastConfig)
    } catch (error) {
      // toast.error('Failed to save Note Id', toastConfig)
    } finally {
      // setIsPageLoading(false)
      // setPatientAppointment(null)
    }
  }
  const patientDataFn = async () => {
    // setIsPageLoading(true)
    try {
      let patientData = await SavePatients('GetAll', '', '', '')
      let patient = JSON.parse(patientData.d).Data
      let appointments = await getAllAppointmentsDetails('GET')
      let schedulePatient = patient?.filter((patient, index) => appointments.find((item) => item.current.Patient.value === patient.PatientID))
      // setPatientData(schedulePatient)
      setAppointment(appointments)

      let count = schedulePatient.length
      // setPatientCount(count)
    } catch (error) {
      console.log(error)
    } finally {
      // setIsPageLoading(false)
    }
  }

  const fetchPatientDataFn = async (PatientID) => {
    // setIsPageLoading(true)
    try {
      // let patientData = await SavePatients('GetAll', '', '', '')
      // let patient = JSON.parse(patientData.d).Data
      // let appointments = await getAllAppointmentsDetails('GET')

      const patientData = await getPatientDetails()
      const appointments = await getAllAppointmentDetails()
      //    let schedulePatient = patient?.filter((patient, index) => appointments.find((item) => item.current.Patient.value === patient.PatientID))
      // setPatientData(schedulePatient)

      let selectedPatient = patientData?.filter((item) => item?.PatientID == PatientID)
      setPatientData(selectedPatient[0])
      setAppointment(appointments)

      let count = schedulePatient.length
      // setPatientCount(count)
    } catch (error) {
      console.log(error)
    } finally {
      // setIsPageLoading(false)
    }
  }

  const patientSelectedFacility = async (rowSelected) => {
    try {
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)

      // setSelectedFacility(userFacilities ? userFacilities : facilities[0]);
      return userFacilities ? userFacilities : facilities[0]
    } catch (e) {}
  }

  const saveDiagnosisData = async (customData) => {
    let a = {}
    let facility = await patientSelectedFacility(customData)

    try {
      a['FacilityID'] = facility?.value.toString() || selectedFacility?.value.toString()
      a['FacilityName'] = facility?.label.toString() || selectedFacility?.label.toString()
      a['Room'] = customData?.Room?.toString() || roomNumber.toString()
    } catch (e) {
      a['FacilityID'] = ''
      a['FacilityName'] = ''
      a['Room'] = -1
    }

    let allDiagnosis = customData?.Diagnosis || ''

    let insurances = addedInsurances.map((ins) => ({
      InsuranceID: ins?.ID,
    }))

    let savePatientInfo
    if (patientID && patientID !== '') {
      savePatientInfo = SavePatients('Update', JSON.stringify(customData ? customData : childformData), JSON.stringify(a), allDiagnosis, patientID, JSON.stringify(insurances))
    } else {
      console.log('patientId Not Found', patientID)
    }

    // await savePatientInfo;

    await patientDataFn()
    // resetStates()
  }

  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' })
  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const noteStructureRef = useRef({})

  const [medicationList, setMedicationList] = useState([])

  const getFacilities = async () => {
    let a = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(a.d)?.Data
    try {
      const formattedData = data.map((facility) => ({
        value: facility.ID,
        label: facility.Name,
      }))
      setFacilities(formattedData)
    } catch (e) {}
  }

  const historyTypeMapping = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }

  const patientSelected = async (rowSelected) => {
    try {
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)
      // setSelectedFacility(userFacilities ? userFacilities : facilities[0]);
      return userFacilities ? userFacilities : facilities[0]
    } catch (e) {}
  }

  const updatePatientDiagnosis = async (patientID, diagnosis) => {
    let patientDiagnosis = diagnosisData[0].Diagnosis.replace(/\"/g, '')
    patientDiagnosis = patientDiagnosis
      .split(',')
      .filter((diagnosis) => diagnosis.trim().length > 0)
      .map((diagnosis) => diagnosis.trim())

    diagnosis = diagnosis.split(',')

    let arr = [...patientDiagnosis, ...diagnosis]
    let mergedArr = [...new Set(arr)]
    let newDiagnosis = mergedArr.join(',')

    let patientAllData = await patientSelected(patientData)
    await ModifyPatientMap('UPDATE', patientID, newDiagnosis, patientAllData?.value)
    await getPatientDiagnosis()
  }

  const editPatientDiagnosis = async (patientID, oldDiagnosis, newDiagnosis) => {
    let patientDiagnosis = diagnosisData[0].Diagnosis.replace(/\"/g, '')
      .split(',')
      .map((diagnosis) => diagnosis.trim())
      .filter((diagnosis) => diagnosis.length > 0)

    let updatedDiagnosis = patientDiagnosis.map((diagnosis) => (diagnosis === oldDiagnosis ? newDiagnosis : diagnosis))

    let finalDiagnosis = [...new Set(updatedDiagnosis)].join(',')

    let patientAllData = await patientSelected(patientData)

    await ModifyPatientMap('UPDATE', patientID, finalDiagnosis, patientAllData?.value)
    await getPatientDiagnosis()
  }

  const handleDeleteDiagnosisFromIndexeddb = async (patientID, filteredNoteDiagnosisID) => {
    let getTestOfflineDataIndex = await getTestOfflineData()
    let noteDiagnosisMetadata = getTestOfflineDataIndex[loggedUserProvider?.ID][patientID]?.currentNote?.data?.metadata?.diagnosisIds || []

    noteDiagnosisMetadata = noteDiagnosisMetadata.filter((id) => id !== filteredNoteDiagnosisID)
    if (
      getTestOfflineDataIndex[loggedUserProvider?.ID] &&
      getTestOfflineDataIndex[loggedUserProvider?.ID][patientID] &&
      getTestOfflineDataIndex[loggedUserProvider?.ID][patientID].currentNote &&
      getTestOfflineDataIndex[loggedUserProvider?.ID][patientID].currentNote.data &&
      getTestOfflineDataIndex[loggedUserProvider?.ID][patientID].currentNote.data.metadata
    ) {
      getTestOfflineDataIndex[loggedUserProvider.ID][patientID].currentNote.data.metadata.diagnosisIds = noteDiagnosisMetadata
    }

    await saveTestOfflineData(getTestOfflineDataIndex)
  }

  const deletePatientDiagnosis = async (patientID, diagnosisToDelete, status) => {
    if (diagnosisData.length === 0) {
      toast.error('No Diagnosis Found', toastConfig)
      return
    }
    let patientDiagnosis = diagnosisData[0].Diagnosis.split(',')
      .map((diagnosis) => diagnosis.trim())
      .filter((diagnosis) => diagnosis.length > 0)

    let updatedDiagnosis = patientDiagnosis.filter((diagnosis) => diagnosis !== diagnosisToDelete)
    if (noteStructureRef.current && noteStructureRef.current.metadata && noteStructureRef.current.metadata.diagnosisIds) {
      // let response = await GetDiagnosisData('')
      let response = await getAllMasterDiagnosis()

      // response = JSON.parse(response.d)?.Data
      response = response?.Data

      const filteredNoteDiagnosis = response?.find((id) => id.Name == diagnosisToDelete)
      // noteStructureRef.current.metadata.diagnosisIds = noteStructureRef.current.metadata.diagnosisIds.filter((id) => id !== filteredNoteDiagnosis?.id)
      // spread notestrucure
      noteStructureRef.current = {
        ...noteStructureRef.current,
        metadata: {
          ...noteStructureRef.current.metadata,
          // diagnosisIds: noteStructureRef.current.metadata.diagnosisIds
          diagnosisIds: noteStructureRef.current.metadata.diagnosisIds.filter((id) => id !== filteredNoteDiagnosis?.id),
        },
      }

      await handleDeleteDiagnosisFromIndexeddb(patientID, filteredNoteDiagnosis?.id)

      //   let status = patientTreatments[noteID] && patientTreatments[noteID]?.status
      //   let flag = patientTreatments[noteID] && patientTreatments[noteID]?.flag
      //   await PatientNoteDataCRUD('UPDATE', patientID.toString(), setDataId?.toString(), JSON.stringify(noteStructureRef.current), getFormattedDate().toString(), status || 'Draft', status || false)
      // }

      // let finalDiagnosis = updatedDiagnosis.join(',')
      // let patientAllData = await patientSelected(patientData)

      // await ModifyPatientMap('UPDATE', patientID, finalDiagnosis, patientAllData?.value)
      await getPatientDiagnosis()
      setDiagnosisAddedPinger((p) => !p)
      showOnlyNoteDiagnosis()
    }
  }
  useEffect(() => {
    getPatientDiagnosis()
  }, [])

  const fetchhDiagnosisMaster = async () => {
    let formattedDataDiagnosis
    // formattedDataDiagnosis = await GetDiagnosisData()
    const getAllMasterDiagnosiss = await getAllMasterDiagnosis()
    let allDiagnosisCodes = {}
    if (getAllMasterDiagnosiss) {
      formattedDataDiagnosis = getAllMasterDiagnosiss?.Data
      for (const diagnosis of formattedDataDiagnosis) {
        allDiagnosisCodes[diagnosis.Name.trim()] = diagnosis.Code
      }
    }
    setDiagnosisCodes(allDiagnosisCodes)
    setMasterDiagnosisData(formattedDataDiagnosis)
  }

  // const getPatientDiagnosis = async () => {
  //   // let diagnosisData = await ModifyPatientMap('GETALL', patientID, '')
  //   // let tempData = JSON.parse(diagnosisData.d)?.Data

  //   // diagnosisData = tempData.filter((obj) => {
  //   //   if (patientID == obj.PatientID) {
  //   //     return obj
  //   //   }
  //   // })
  //   const getTestOfflineDataIndex = await getTestOfflineData()
  //   let diagnosisData = getTestOfflineDataIndex[loggedUserProvider?.ID][patientID]?.diagnosisDataModifyMap

  //   let patientD = []
  //   try {
  //     let diagnosisData = getTestOfflineDataIndex[loggedUserProvider?.ID][patientID]?.diagnosisDataModifyMap

  //     patientD = diagnosisData[0]?.Diagnosis?.split(',')
  //     //  patientD = diagnosisData?.split(',')
  //   } catch (e) { }

  //   // setPatientDiagnosis(patientD) patient diagnosis was setting from here we have diagnosis note wise
  //   let plans = {}
  //   let assessment = {}
  //   // (patientD || [])?.forEach((item) => {
  //   //   (plans[item] = ''),
  //   //     (assessment[item] = {
  //   //       MobilityAssessment: {},
  //   //       POA: '',
  //   //       MorseScore: {},
  //   //       LabImaging: '',
  //   //       FreeType: '',
  //   //       selfCareAssessment: {},
  //   //     })
  //   // })

  //   // noteStructureRef.current = {
  //   //   ...noteStructureRef.current,
  //   //   plans,
  //   // }
  //   setDiagnosisData(diagnosisData)
  // }
  const getPatientDiagnosis = async () => {
    try {
      const getTestOfflineDataIndex = await getTestOfflineData()
      let diagnosisData = await getTestOfflineDataIndex[loggedUserProvider?.ID][patientID]?.diagnosisDataModifyMap
      setDiagnosisData(diagnosisData)
    } catch (e) {
      console.log('=======>>>getPatientDiagnosis', error)
    }
  }

  const handleTabClick = (index) => {
    // autoSaveTreatsShell()
    setActiveTab(index)
  }

  // get patient history
  // const getHistory = async () => {
  //   let allData = await ModifyPatientHistory('GET', patientID)
  //   let history = JSON.parse(allData?.d)
  //   setAllHistory(history?.Data)

  //   let allHistory = history?.Data
  //   return history?.Data
  // }

  const getHistory = async () => {
    setAllHistory(patientDBData?.hospitalRecords?.Data || [])
    let allHistory = patientDBData?.hospitalRecords?.Data || []
    if (allHistory.length > 0) {
      localStorage.setItem('PatientHospitalRecords', allHistory[allHistory.length - 1].History)
    } else {
      localStorage.setItem('PatientHospitalRecords', '')
    }
  }

  const SyncAppointmentData = (noteID) => {
    let filterPatient = appointments && appointments.length > 0 && appointments.filter((item) => item.current.Patient.value === patientID && (item.data.Status == 'Scheduled' || item.data.Status == 'Rescheduled') && !item.data.NoteID)

    try {
      if (filterPatient.length > 0) {
        if (noteID !== null || noteID !== undefined) {
          handleAddNoteId(noteID)
        }
      }
    } catch (error) {
      console.error('Error syncing appointment data:', error)
    }
  }
  // Get Patient Treatments

  // const GetPatientTreatmentsNotes = async () => {
  //   try {
  //     let data
  //     data = await PatientNoteDataCRUD('GET', patientID)
  //     if (data) {
  //       data = JSON.parse(data.d)?.Data
  //       data = data?.map((item) => {
  //         return {
  //           ...item,
  //           data: item?.data ? JSON.parse(item?.data) : {},
  //         }
  //       })

  //       // noteStructureRef.current = data[noteID]?.data
  //       // setSelectedRisks(data[noteID]?.data.riskFactors || {})
  //       noteStructureRef.current = data[noteID]?.data

  //       if (data?.length === 0) {
  //         let provideInformation = patientData.Diagnosis.split(',')

  //         let information = provideInformation.reduce((acc, item) => {
  //           acc[item] = ['Patient Added']
  //           return acc
  //         }, {})
  //         let assessment = {}

  //         patientDiagnosis.forEach((item) => {
  //           assessment[item] = {
  //             MobilityAssessment: {},
  //             POA: '',
  //             MorseScore: {},
  //             LabImaging: '',
  //             FreeType: '',
  //             selfCareAssessment: {},
  //           }
  //         })

  //         noteStructureRef.current = {
  //           ...noteStructureRef.current,
  //           information,
  //           assessment,
  //         }
  //       } else {
  //         SyncAppointmentData(data[noteID]?.id)
  //         if (data[noteID]?.data?.orderProviderFlag === false || noteID === 0 || data[noteID]?.status === 'Submitted' || (data[noteID]?.flag == 'true' && data[noteID]?.status == 'Draft') || data[noteID]?.status === 'Signed') {
  //           setShowOrderPopUp(false)
  //         }

  //         try {
  //           let filterPatient = appointments && appointments.length > 0 && appointments.filter((item) => item?.current?.Patient?.value === patientID && item?.data?.Status === 'Finish')
  //           let lastAppointmentDate = filterPatient?.[filterPatient.length - 1]?.data?.CreatedDate || null
  //           if (lastAppointmentDate) {
  //             const datePart = lastAppointmentDate.split('T')[0]
  //             const usFormattedDate = new Date(datePart).toLocaleDateString('en-US')
  //             setAppointmentData(usFormattedDate)
  //           } else {
  //             setAppointmentData(filterPatient?.[0]?.data?.StartTime || '')
  //           }
  //         } catch (error) {
  //           console.error('Error processing appointment data:', error)
  //           setAppointmentData(null)
  //         }
  //         // if (filterPatient.length > 0) {
  //         //   handleAddNoteId(data[noteID].id || null)
  //         // }

  //         if (!data[noteID]?.data.information) {
  //           noteStructureRef.current = {
  //             ...noteStructureRef.current,
  //             information: data[0]?.data.information || {},
  //           }
  //         }
  //         if (data[noteID]?.data.riskFactors) {
  //           setSelectedRisks(data[noteID]?.data.riskFactors || {})
  //         }

  //         // let assessment = {}

  //         // patientDiagnosis.forEach((item) => {
  //         //   assessment[item] = {
  //         //     MobilityAssessment: {},
  //         //     POA: "",
  //         //     MorseScore: {},
  //         //     LabImaging: "",
  //         //     FreeType: "",
  //         //   }
  //         // })
  //         // noteStructureRef.current = {
  //         //   ...noteStructureRef.current,
  //         //   assessment: assessment
  //         // }
  //       }

  //       setPatientTreatments(data)
  //     }
  //   } catch (error) {
  //     // toast.error('error in patient treatment', toastConfig)
  //     console.error('Error fetching patient orders', error)
  //   }
  // }

  const GetPatientTreatmentsNotes = async () => {
    try {
      //  let data
      // data = await PatientNoteDataCRUD('GET', patientID)

      let data = patientDBData?.allNotes

      if (data) {
        data = data?.map((item) => {
          return {
            ...item,
            data: item?.data ? JSON.parse(item?.data) : {},
          }
        })

        // noteStructureRef.current = data[noteID]?.data
        // setSelectedRisks(data[noteID]?.data.riskFactors || {})
        //  noteStructureRef.current = data[noteID]?.data

        if (data?.length === 0) {
          let provideInformation = patientData.Diagnosis.split(',')

          let information = provideInformation.reduce((acc, item) => {
            acc[item] = ['Patient Added']
            return acc
          }, {})
          let assessment = {}

          patientDiagnosis.forEach((item) => {
            assessment[item] = {
              MobilityAssessment: {},
              POA: '',
              MorseScore: {},
              LabImaging: '',
              FreeType: '',
              selfCareAssessment: {},
            }
          })

          noteStructureRef.current = {
            ...noteStructureRef.current,
            information,
            assessment,
          }
        } else {
          SyncAppointmentData(data[noteID]?.id)
          if (data[noteID]?.data?.orderProviderFlag === false || noteID === 0 || data[noteID]?.status === 'Submitted' || (data[noteID]?.flag == 'true' && data[noteID]?.status == 'Draft') || data[noteID]?.status === 'Signed') {
            setShowOrderPopUp(false)
          }

          try {
            let filterPatient = appointments && appointments.length > 0 && appointments.filter((item) => item?.current?.Patient?.value === patientID && item?.data?.Status === 'Finish')
            let lastAppointmentDate = filterPatient?.[filterPatient.length - 1]?.data?.CreatedDate || null
            if (lastAppointmentDate) {
              const datePart = lastAppointmentDate.split('T')[0]
              const usFormattedDate = new Date(datePart).toLocaleDateString('en-US')
              setAppointmentData(usFormattedDate)
            } else {
              setAppointmentData(filterPatient?.[0]?.data?.StartTime || '')
            }
          } catch (error) {
            console.error('Error processing appointment data:', error)
            setAppointmentData(null)
          }
          // if (filterPatient.length > 0) {
          //   handleAddNoteId(data[noteID].id || null)
          // }

          if (!data[noteID]?.data.information) {
            noteStructureRef.current = {
              ...noteStructureRef.current,
              information: data[0]?.data.information || {},
            }
          }
          if (data[noteID]?.data.riskFactors) {
            setSelectedRisks(data[noteID]?.data.riskFactors || {})
          }

          // let assessment = {}

          // patientDiagnosis.forEach((item) => {
          //   assessment[item] = {
          //     MobilityAssessment: {},
          //     POA: "",
          //     MorseScore: {},
          //     LabImaging: "",
          //     FreeType: "",
          //   }
          // })
          // noteStructureRef.current = {
          //   ...noteStructureRef.current,
          //   assessment: assessment
          // }
        }

        setPatientTreatments(data)
      }
    } catch (error) {
      // toast.error('error in patient treatment', toastConfig)
      console.error('Error fetching patient orders', error)
    }
  }
  noteStructureRef.current = {
    ...noteStructureRef.current,
  }
  // patient imaging =================================================================>>>>
  const [render, setRender] = useState(false)
  const [imagingTypeList, setImagingTypeList] = useState([])
  const [imagingList, setImagingList] = useState([])

  const getPatientHistory = async () => {
    let newHistories = patientDBData?.patientHistories || {}
    // Update all histories at once
    setHistories((prevHistories) => ({
      ...prevHistories,
      ...newHistories,
    }))
  }

  useEffect(() => {
    // fetch risk from db
    const fetchRisk = async () => {
      const offlineData = (await noteCallType) === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
      let riskFactors = await offlineData[loggedUserProvider?.ID][patientID]?.currentNote?.data?.riskFactors
    }
    fetchRisk()
  }, [loggedUserProvider, patientID])

  // const getPatientHistory = async () => {
  //   let newHistories = {}

  //   // Loop through all history types
  //   for (const [key, historyType] of Object.entries(historyTypeMapping)) {
  //     try {
  //       const allData = await getPatientPersonalHistory('GET', patientID, historyType, '')
  //       const formattedData = JSON.parse(allData?.d)

  //       if (formattedData && formattedData.Data) {
  //         newHistories[key] = formattedData.Data
  //       }
  //     } catch (error) {
  //       console.error(`Error fetching ${historyType}:`, error)
  //       // You could optionally add fallback or error info to newHistories[key] = ...
  //     }
  //   }

  //   // Update all histories at once
  //   setHistories((prevHistories) => ({
  //     ...prevHistories,
  //     ...newHistories,
  //   }))
  // }

  const getData = async () => {
    try {
      // const data = await ImagingInformation('GET_ALL')
      // if (data) {

      // }
      // const formattedData = JSON.parse(data.d)?.Data
      const formattedData = await getImagingInformationData()
      const allFormattedData = formattedData
        .filter((item) => item.Keywords !== '')
        .map((item) => {
          return {
            ...item,
            Keywords: JSON.parse(JSON.parse(item.Keywords)),
          }
        })
      setImagingTypeList(allFormattedData)
      setRender((p) => !p)
    } catch (error) {
      console.error('Error fetching imaging data', error)
    }
  }

  const getTestOfflineDataToNoteStructure = async () => {
    try {
      const offlineData = await getTestOfflineData()
      if (!offlineData) return

      const providerDetails = await getProviderDetails()
      const providerId = providerDetails?.ID
      const providerData = offlineData[providerId] || {}
      const patientData = providerData[patientIDClicked] || {}
      const patientCurrentNote = patientData?.currentNote?.data || {}
      noteStructureRef.current = patientCurrentNote
    } catch (error) {
      console.error('Error in getTestOfflineDataToNoteStructure:', error)
    }
  }
  useEffect(() => {
    getTestOfflineDataToNoteStructure()
  }, [patientIDClicked])

  const extractUniqueKeywords = (keywordsArray) => {
    const allKeywords = keywordsArray.flatMap((item) => item.keyword.split(',')).map((keyword) => keyword.trim())

    const uniqueKeywords = Array.from(new Set(allKeywords))

    return uniqueKeywords
  }

  // get master medications
  const GetMasterMedications = async () => {
    try {
      // let allMedicines = await MedicineCRUD('GET')
      // let formattedData = JSON.parse(allMedicines.d)?.Data
      let formattedData = await getMedicationinformationData()
      if (formattedData) {
        formattedData = formattedData?.Data.map((item) => {
          let itemData = JSON.parse(item.Data)
          return {
            ...item,
            Data: {
              ...itemData,
              diagnoses: itemData.diagnoses.split(',').map((diagnosis) => diagnosis.trim()) || [],
            },
          }
        })
        setMasterMedications(formattedData)
      }
    } catch (error) {
      console.error('Error fetching master medications:', error)
    }
  }
  // const formattedMedsData = await getMedicationMasterData()

  // get patient imaging
  const GetPatientImagings = async () => {
    try {
      // let formattedDatass = await PatientImagingsCRUD('GET', patientID.toString())
      // if (formattedDatass) {
      //   formattedDatass = JSON.parse(formattedDatass.d)
      //   formattedDatass = formattedDatass.Data.map((item) => {
      //     const parsedData = JSON.parse(item.data)
      //     const matchingType =
      //       parsedData &&
      //       imagingTypeList.find((type) => {
      //         return type.Name.toString() === parsedData.name.toString()
      //       })
      //     return {
      //       ...item,
      //       data: {
      //         ...parsedData,
      //         keywords: matchingType ? extractUniqueKeywords(matchingType.Keywords) : [],
      //       },
      //     }
      //   })
      // }
      //   formattedDatass.sort((a, b) => new Date(b?.date) - new Date(a?.date))

      let formattedData = (patientDBData?.allImaging || [])?.map((item) => {
        // const parsedData = JSON.parse(item.data)
        const parsedData = item.data
        const matchingType =
          parsedData &&
          imagingTypeList.find((type) => {
            return type.Name.toString() === parsedData.name.toString()
          })
        return {
          ...item,
          data: {
            ...parsedData,
            keywords: matchingType ? extractUniqueKeywords(matchingType.Keywords) : [],
          },
        }
      })
      formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date))

      setImagingList(formattedData)
      return formattedData
    } catch (error) {
      console.error('Error fetching patient imaging data', error)
    }
  }

  // useEffect(() => {
  //   setIsPatientPageLoading(true)
  //   try {
  //     const fetchData = async () => {
  //       await getData();
  //       await GetMasterMedications()
  //       await getHistory()
  //       await GetPatientImagings();
  //       await getPatientVitals()
  //       await fetchMedications()
  //       await fetchPatientLabs()
  //       await fetchAllergies()
  //       await fetchhDiagnosisMaster()
  //       await fetchOrders()
  //       await GetPatientTreatmentsNotes()
  //     };
  //     fetchData();
  //   } catch (error) {
  //     console.log(error)
  //   }
  //   finally{
  //     setIsPatientPageLoading(false)
  //   }
  // }, [patientID, reRender]);

  useEffect(() => {
    const fetchPatientAllData = async () => {
      setIsPatientPageLoading(true)
      try {
        await Promise.all([getData(), GetMasterMedications(), getHistory(), GetPatientImagings(), getPatientHistory(), getPatientVitals(), fetchMedications(), fetchPatientLabs(), fetchAllergies(), fetchhDiagnosisMaster(), fetchOrders(), GetPatientTreatmentsNotes()])
      } catch (error) {
        console.error('Error fetching patient data:', error)
      } finally {
        setIsPatientPageLoading(false)
      }
    }

    fetchPatientAllData()
  }, [patientID, reRender, patientDBData])

  useEffect(() => {
    GetPatientImagings()
  }, [render])
  // patient imaging =================================================================>>>>

  // all master imaging gets

  // all master imaging gets

  // patient vitals ============

  // const getPatientVitals = async () => {
  //   let allVital = { PatientID: patientID }
  //   allVital = [allVital]
  //   let allData
  //   allData = await fetchPatientData('GET', 'Vitals', JSON.stringify(allVital))

  //   allData = JSON.parse(allData.d) || {}

  //   setVitalsList(allData?.Data)
  // }
  const getPatientVitals = async () => {
    setVitalsList(patientDBData?.patientVitals || [])
  }
  // patient vitals ============

  // patient labs ============

  // scroll
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  // const fetchPatientLabs = async () => {
  //   try {
  //     let formattedData
  //     formattedData = await PatientLabsCRUD('GET', patientID.toString())
  //     formattedData = JSON.parse(formattedData.d)
  //     formattedData = formattedData?.Data || []
  //     if (formattedData) {
  //       formattedData = formattedData?.map((item) => {
  //         return {
  //           ...item,
  //           data: JSON.parse(item.data),
  //         }
  //       })
  //     }
  //     formattedData.sort((a, b) => b.id - a.id)
  //     setAllLabs(formattedData)
  //     return formattedData
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  const fetchPatientLabs = async () => {
    try {
      setAllLabs(patientDBData?.patientLabData || [])
      return patientDBData?.patientLabData
    } catch (error) {
      console.log(error)
    }
  }

  // patient labs ============

  //  <<<<<========= patient medications =================================================================>>>>>
  // const fetchMedications = async () => {
  //   let formattedData
  //   formattedData = await PatientMedications('GET', patientID.toString())
  //   formattedData = JSON.parse(formattedData.d)
  //   formattedData = formattedData?.Data
  //   const masterMedsNames = masterMedications.map((med) => med.Data.name)
  //   if (formattedData) {
  //     formattedData = formattedData.map((item) => {
  //       return {
  //         ...item,
  //         data: JSON.parse(
  //           item.data.length > 0 && Array.isArray(item.data) && item.data.map((item) => {
  //             return {
  //               ...item,
  //               inMaster: masterMedsNames.includes(item.name) ? true : false,
  //             }
  //           })
  //         ),
  //       }
  //     })
  //   }
  //   formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date))
  //   setMedicationList(formattedData)
  //   return formattedData
  // }
  const fetchMedications = async () => {
    let formattedData

    // const response = await PatientMedications('GET', patientID.toString())
    // formattedData = JSON.parse(response.d)
    // formattedData = formattedData?.Data

    const data = await getTestOfflineData()

    formattedData = data?.[loggedUserProvider?.ID]?.[patientID]?.allMedications || []

    const masterMedsNames = masterMedications.map((med) => med.Data?.name?.toLowerCase())

    if (formattedData) {
      formattedData = formattedData.map((item) => {
        // let parsedData = []
        // try {
        //   parsedData = item.data ? JSON.parse(item.data) : []
        // } catch (e) {
        //   console.error('Error parsing item.data:', e, item.data)
        // }

        const updatedData = Array.isArray(item?.data)
          ? item?.data?.map((med) => ({
              ...med,
              inMaster: masterMedsNames.includes(med?.name?.toLowerCase()),
            }))
          : []
        updatedData.sort((a, b) => (a.inMaster === b.inMaster ? 0 : a.inMaster ? -1 : 1))

        return {
          ...item,
          data: updatedData,
        }
      })
    }

    formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date))

    setMedicationList(formattedData)
    return formattedData
  }

  //  <<<<<========= patient medications =================================================================>>>>>

  // patient allergies
  const fetchAllergies = async () => {
    try {
      // let formattedData
      // // patientAllergy
      // formattedData = await GetPatientAllergiesCRUD('GET', patientID)
      // formattedData = JSON.parse(formattedData.d)
      // formattedData = formattedData?.Data || []
      // if (formattedData) {
      //   formattedData = formattedData?.map((item) => {
      //     return {
      //       ...item,
      //       data: JSON.parse(item.data),
      //     }
      //   })
      // }
      // setAllergiesList(formattedData)
    } catch (error) {}
  }
  // patient allergies

  // patient orders

  const fetchOrders = async () => {
    try {
      // let formattedData
      // formattedData = await PatientOrdersCRUD('GET', patientID)
      // formattedData = JSON.parse(formattedData.d)
      // formattedData = formattedData?.Data || []
      // if (formattedData) {
      //   formattedData = formattedData.map((item, idx) => {
      //     return {
      //       ...item,
      //       medication: item.medication == '' ? [] : JSON.parse(item.medication),
      //       imaging: item.imaging.length > 0 ? JSON.parse(item?.imaging) : {},
      //       medication: item.medication ? JSON.parse(item.medication) : {},
      //       labs: item.labs.length > 0 ? JSON.parse(item?.labs) : {},
      //     }
      //   })
      // }
      // setPatientOrders(formattedData)
    } catch (error) {
      console.log(error)
    }
  }

  // patient orders

  const [appointmentForthisPatient, setAppointmentForthisPatient] = useState({})
  const [isSuperbillUpdateOrSubmitted, setIsSuperbillUpdateOrSubmitted] = useState(false)
  const getAppointmentForThisPatientScheduled = async () => {
    // const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '')
    // const result = await PatientAppointmentDetails('GET', '', '', '', '')
    const result = await getAllAppointmentData()
    const rawData = JSON.parse(result.d)?.Data || []
    let structuredData = []

    rawData.forEach((item) => {
      let parsedList = JSON.parse(item?.AppointmentDetails)

      if (Array.isArray(parsedList)) {
        parsedList.forEach((parsedItem) => {
          const patientID = parsedItem?.patientID
          const appointmentDetails = parsedItem?.appointmentDetails || []

          const formattedAppointments = appointmentDetails.map((appointment) => {
            const data = appointment?.data || {}
            const current = appointment?.current || {
              Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
              Provider: { value: '', label: data?.ProviderName || 'Unknown' },
              Facility: { value: '', label: data?.Facility || 'Unknown' },
              Insurance: data?.Insurance || {},
              otherDetails: data?.otherDetails || {},
            }

            return { data, current }
          })

          structuredData.push({
            patientID,
            appointmentDetails: formattedAppointments,
          })
        })
      } else {
        console.warn('Unexpected non-array parsed data:', parsedList)
      }
    })

    const matchAppointment = structuredData.find((appt) => appt.patientID === patientID)

    if (!matchAppointment) return

    const allMatchedAppointmentAppointmentDetails = matchAppointment?.appointmentDetails || []

    if (allMatchedAppointmentAppointmentDetails.length === 0) return

    const MatchedAppointment = allMatchedAppointmentAppointmentDetails.find((item) => item?.data?.Status === 'Scheduled')

    setAppointmentForthisPatient(MatchedAppointment)
  }

  useEffect(() => {
    getAppointmentForThisPatientScheduled()
  }, [])

  useEffect(() => {
    getPatientDiagnosis()
  }, [patientID, diagnosisAddedPinger, loggedUserProvider])

  // Display patient details

  let navLinks = [
    // { title: 'PI', tab: 0 },
    { title: 'BoNT', tab: 21 },
    // { title: 'Note', tab: 10 },
    { title: 'HR', tab: 28 },
    { title: 'PHx', tab: 24 },
    { title: 'OD', tab: 29 },
    { title: patientData?.Status === 'Follow Up' ? 'Sub' : 'HPI', tab: 30 },
    { title: 'Inc', tab: 31 },
    { title: 'ROS', tab: 32 },
    { title: 'PE', tab: 33 },
    { title: 'POAC', tab: 23 },
    { title: 'A/P', tab: 22 },
    // { title: 'Meds', tab: 8 },
    // { title: 'Labs', tab: 7 },
    // { title: 'Imgs', tab: 6 },
    { title: 'OS', tab: 9 },
    // { title: 'Orders', tab: 9 },
    // { title: 'Rpts', tab: 16 },
    { title: 'SB', tab: 27 },
    { title: 'EDU', tab: 26 },
    //   { title: 'Addendum', tab: 18 },
    // { title: 'FaceSheet', tab: 1 },
    // { title: 'BONT', tab: 0 },
    // { title: 'Hospital Records', tab: 2 },
    // { title: 'Hospital Records', tab: 13 },
    // { title: 'History', tab: 3 },
    // { title: 'Internal Notes', tab: 4 },
    // { title: 'Vitals', tab: 5 },
    // { title: 'Allergies', tab: 13 },
    // { title: 'Reports', tab: 16 },

    // { title: 'HPI Questions', tab: 17 },
    // {title: 'Past Notes', tab: 20 },

    // { title: 'Treatment Plan', tab: 10 },
    // { title: 'Assessment', tab: 11 },
    // { title: 'Final Note', tab: 12 },
    // Add more nav links here
  ]
  // if (patientTreatments[noteID || 0]?.status === "Signed" || patientTreatments[noteID || 0]?.status === "Finished") {
  //     navLinks = [
  //         { title: 'Orders', tab: 9 },
  //         { title: 'POAC', tab: 23 },

  //         // Add more nav links here
  //     ];
  // } else {
  //     navLinks = [
  //         { title: 'BONt', tab: 21 },
  //         { title: 'Note', tab: 10 },
  //         { title: 'Treatment Shell', tab: 22 },
  //         { title: 'POAC', tab: 23 },
  //         { title: 'PHx', tab: 24 },
  //         { title: 'Medication', tab: 8 },
  //         { title: 'Labs', tab: 7 },
  //         { title: 'Imaging', tab: 6 },
  //         { title: 'Orders', tab: 9 },
  //         // { title: 'Orders', tab: 9 },
  //         { title: 'Reports', tab: 16 },
  //         { title: 'Education', tab: 26 },
  //         { title: 'Super Bill', tab: 27 },
  //         //   { title: 'Addendum', tab: 18 },
  //         // { title: 'FaceSheet', tab: 1 },
  //         // { title: 'BONT', tab: 0 },
  //         // { title: 'Hospital Records', tab: 2 },
  //         // { title: 'Hospital Records', tab: 13 },
  //         // { title: 'History', tab: 3 },
  //         // { title: 'Internal Notes', tab: 4 },
  //         // { title: 'Vitals', tab: 5 },
  //         // { title: 'Allergies', tab: 13 },
  //         // { title: 'Reports', tab: 16 },

  //         // { title: 'HPI Questions', tab: 17 },
  //         // {title: 'Past Notes', tab: 20 },

  //         // { title: 'Treatment Plan', tab: 10 },
  //         // { title: 'Assessment', tab: 11 },
  //         // { title: 'Final Note', tab: 12 },
  //         // Add more nav links here
  //     ];
  // }
  // Define an array of nav links

  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)
  useEffect(() => {
    dispatch({ type: 'set', sidebarShow: false })
    getFacilities()
  }, [])

  const handleInsertData = async () => {
    try {
      let data
      data = await PatientNoteDataCRUD('GET', patientID)

      if (data) {
        data = JSON.parse(data.d)?.Data
        data = data?.map((item) => {
          return {
            ...item,
            data: item?.data ? JSON.parse(item?.data) : {},
          }
        })

        setEditDataId(data.length)
        setDataCallType('edit')
      }
    } catch (error) {
      // toast.error('error in patient treatment', toastConfig)
      console.error('Error fetching patient orders', error)
    }
  }

  const handleSaveModule = () => {
    if (patientTreatments && patientTreatments.length > 0) {
      let setUpID = patientTreatments[noteID]

      if (setUpID?.status === 'Submitted') {
        setShowSaveModel(true)
      } else if (setUpID?.status === 'Signed') {
        setSignModel(true)
      } else {
        saveTreatsShell()
      }
    } else {
      saveTreatsShell()
    }
  }
  const handleSubmitModule = () => {
    if (patientTreatments && patientTreatments.length > 0) {
      let setUpID = patientTreatments[noteID]
      if (setUpID?.status === 'Signed') {
        setSignModel(true)
      } else {
        submitNotes()
      }
    } else {
      submitNotes()
    }
  }

  useEffect(() => {
    const settingNoteIdFunc = async () => {
      // Only aded noteID if the key does not exist in the object
      if (noteStructureRef && noteStructureRef.current) {
        if (!Object.prototype.hasOwnProperty.call(noteStructureRef.current, 'noteID')) {
          noteStructureRef.current = {
            ...noteStructureRef.current,
            noteID: Number(noteID),
          }
        }
        await PatientNoteDataCRUD('UPDATE', patientID.toString(), setDataId, JSON.stringify(noteStructureRef.current), getFormattedDate().toString(), 'Draft', false)
      }
      if (noteStructureRef.current) {
        settingNoteIdFunc()
      }
    }
  }, [noteStructureRef.current])

  // const saveTreatsShell = async (showAlert = true, addExtraInfoToNote = {}) => {
  //   noteStructureRef.current = {
  //     ...noteStructureRef.current,
  //     // DifferentialDiagnosis: null,
  //     ...addExtraInfoToNote,
  //     noteID: Number(noteID),
  //   }
  //   if (patientTreatments && patientTreatments.length > 0 && dataCallType === 'edit') {
  //     const formattedJson = JSON.stringify(noteStructureRef.current)
  //     let setUpID = patientTreatments[noteID] && patientTreatments[noteID]?.id
  //     // let statuToCurrentNoteSave = patientTreatments[noteID] && patientTreatments[noteID]?.status || 'Draft'

  //     await PatientDataCRUD('UPDATE', patientID.toString(), setUpID.toString(), formattedJson, getFormattedDate().toString(), 'Draft', 'true')
  //     await GetPatientTreatmentsNotes()
  //     if (showAlert) {
  //       toast.success('Successfully Save', toastConfig)
  //     }
  //   } else {
  //     const formattedJson = JSON.stringify(noteStructureRef.current)
  //     await PatientDataCRUD('INSERT', patientID.toString(), '', formattedJson, getFormattedDate().toString(), 'Draft', 'true')
  //     if (showAlert) {
  //       toast.success('Successfully Save', toastConfig)
  //     }

  //     handleInsertData()
  //     await GetPatientTreatmentsNotes()
  //   }
  // }

  const saveTreatsShell = async (showAlert = true, addExtraInfoToNote = {}) => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      // DifferentialDiagnosis: null,
      ...addExtraInfoToNote,
      noteID: Number(noteID),
    }
    if (patientTreatments && patientTreatments.length > 0 && dataCallType === 'edit') {
      const formattedJson = JSON.stringify(noteStructureRef.current)
      let setUpID = patientTreatments[noteID] && patientTreatments[noteID]?.id
      // let statuToCurrentNoteSave = patientTreatments[noteID] && patientTreatments[noteID]?.status || 'Draft'

      await addNoteDeatilsInLs('UPDATE', patientID.toString(), setUpID.toString(), formattedJson, getFormattedDate().toString(), 'Draft', 'true')
      // await PatientDataCRUD('UPDATE', patientID.toString(), setUpID.toString(), formattedJson, getFormattedDate().toString(), 'Draft', 'true')
      await GetPatientTreatmentsNotes()
      if (showAlert) {
        toast.success('Successfully Save', toastConfig)
      }
    } else {
      const formattedJson = JSON.stringify(noteStructureRef.current)
      await addNoteDeatilsInLs('INSERT', patientID.toString(), '', formattedJson, getFormattedDate().toString(), 'Draft', 'true')
      // await PatientDataCRUD('INSERT', patientID.toString(), '', formattedJson, getFormattedDate().toString(), 'Draft', 'true')
      if (showAlert) {
        toast.success('Successfully Save', toastConfig)
      }

      handleInsertData()
      await GetPatientTreatmentsNotes()
    }
  }

  useEffect(() => {
    if (noteStructureRef.current && patientTreatments && patientTreatments.length > 0 && dataCallType === 'edit' && noteStructureRef.current.metadata && Array.isArray(noteStructureRef.current.metadata.tempIds) && noteStructureRef.current.metadata.tempIds.length > 0) {
      noteStructureRef.current = {
        ...noteStructureRef.current,
        metadata: {
          ...noteStructureRef.current.metadata,
          tempIds: [],
        },
      }
      saveTreatsShell(false)
    }
  }, [])

  // },[])

  const autoSaveTreatsShell = async () => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      // DifferentialDiagnosis: null,
      noteID,
    }

    if (patientTreatments && patientTreatments.length > 0 && dataCallType === 'edit') {
      const formattedJson = JSON.stringify(noteStructureRef.current)
      let setUpID = patientTreatments[noteID] && patientTreatments[noteID]?.id
      let status = patientTreatments[noteID] && patientTreatments[noteID]?.status
      let flag = patientTreatments[noteID] && patientTreatments[noteID]?.flag

      await PatientDataCRUD('UPDATE', patientID.toString(), setUpID.toString(), formattedJson, getFormattedDate().toString(), status, flag)
      await GetPatientTreatmentsNotes()
    } else {
      const formattedJson = JSON.stringify(noteStructureRef.current)

      await PatientDataCRUD('INSERT', patientID.toString(), '', formattedJson, getFormattedDate().toString())
      handleInsertData()
      await GetPatientTreatmentsNotes()
    }
  }

  const updatePatientTodaysAppointment = async (ID) => {
    const getTodaysAppointment = await getAllTodaysAppointment()
    const parsedAppointment = JSON.parse(getTodaysAppointment)
    const filterAppointment = parsedAppointment.filter((item) => item.PatientID !== parseInt(ID))
    await saveAllTodaysAppointment(JSON.stringify(filterAppointment))

    const getOpenChartAppointment = localStorage.getItem('patientTreatmentsNotes')
    if (!getOpenChartAppointment) {
      return
    }
    let parsedOpenChartAppointment
    try {
      parsedOpenChartAppointment = JSON.parse(getOpenChartAppointment)
    } catch (err) {
      console.error('Invalid JSON in patientTreatmentsNotes:', err)
      return
    }
    const filterOpenChartAppointment = parsedOpenChartAppointment?.filter((item) => item.PatientID !== parseInt(ID)) || []

    localStorage.setItem('patientTreatmentsNotes', JSON.stringify(filterOpenChartAppointment))
  }

  const addNoteDeatilsInLs = async (Mode, patientID, id, formateData, date, status, flag, appointmentId, patientDetails) => {
    const data = await getTestOfflineData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }
    const newlyAddedData = patientData.newlyAddedData || []

    const updateTodaysApppointment = await updatePatientTodaysAppointment(patientID)
    const updateNote = {
      Mode,
      id,
      formateData,
      date,
      patientID,
      status,
      flag,
      appointmentId,
      patientDetails,
    }

    const updatedPatientData = {
      ...patientData,
      //  currentNote: updateNote,
      newlyAddedData: { ...newlyAddedData, currentNote: updateNote },
    }

    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }

    await saveTestOfflineData(updatedData)
  }

  const [signLoaderModel, setSignLoaderModel] = useState(false)
  // const submitNotes = async (addExtraData = {}) => {
  //   setSignLoaderModel(true)
  //   const today = new Date()
  //   const formattedDateTime = today.toLocaleString('en-US', {
  //     year: 'numeric',
  //     month: '2-digit',
  //     day: '2-digit',
  //     hour: '2-digit',
  //     minute: '2-digit',
  //     hour12: true,
  //   })

  //   noteStructureRef.current = {
  //     ...noteStructureRef.current,
  //     ...(Object.keys(addExtraData).length > 0 ? addExtraData : {}),
  //     // DifferentialDiagnosis: null,
  //     noteID,
  //     signedAt: formattedDateTime,
  //   }

  //   const formattedJson = JSON.stringify(noteStructureRef.current)

  //   try {
  //     let appointmentNoteId = setDataId ? setDataId.toString() : patientTreatments[noteID] && patientTreatments[noteID]?.id
  //     const filteNoteAppointment = appointments?.filter((item) => item.data.NoteID == appointmentNoteId)
  //     const appointmentId = filteNoteAppointment[0]?.data?.AppointmentID

  //     if (appointmentId) {
  //       const success = await handleAppointmentSubmit(appointmentId, patientData)
  //       if (success) {
  //         await handleAutoSchedule(patientData, appointmentId)
  //       }
  //     } else {
  //       toast.error('Something went wrong while signing the appointment. Please try again.', toastConfig)
  //     }
  //   } catch (error) {
  //     console.error('error while auto-scheduling', error)
  //     setSignLoaderModel(false)
  //   }

  //   if (setDataId) {
  //     let setUpID = setDataId ? setDataId.toString() : patientTreatments[noteID] && patientTreatments[noteID]?.id
  //     await PatientDataCRUD('UPDATE', patientID.toString(), setDataId ? setDataId.toString() : setUpID.toString(), formattedJson, getFormattedDate().toString(), 'Signed', 'true')
  //     toast.success('Successfully Signed', toastConfig)
  //   } else {
  //     await PatientDataCRUD('INSERT', patientID.toString(), '', formattedJson, getFormattedDate().toString(), 'Signed', 'true')
  //     handleInsertData()
  //     toast.success('Successfully Signed', toastConfig)
  //   }

  //   await GetPatientTreatmentsNotes()
  //   setModalVisible(false)
  //   setIsAckChecked(false)
  //   setSignLoaderModel(false)
  // }

  const submitNotes = async (addExtraData = {}) => {
    setSignLoaderModel(true)
    const today = new Date()
    const formattedDateTime = today.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })

    noteStructureRef.current = {
      ...noteStructureRef.current,
      ...(Object.keys(addExtraData).length > 0 ? addExtraData : {}),
      // DifferentialDiagnosis: null,
      noteID,
      signedAt: formattedDateTime,
    }

    const formattedJson = JSON.stringify(noteStructureRef.current)
    let appointmentId
    try {
      let appointmentNoteId = setDataId ? setDataId.toString() : patientTreatments[noteID] && patientTreatments[noteID]?.id
      const filteNoteAppointment = appointments?.filter((item) => item.data.NoteID == appointmentNoteId)
      appointmentId = filteNoteAppointment[0]?.data?.AppointmentID

      //  if (appointmentId) {
      //    const success = await handleAppointmentSubmit(appointmentId, patientData)
      //    if (success) {
      //      await handleAutoSchedule(patientData, appointmentId)
      //    }
      //  } else {
      //    toast.error('Something went wrong while signing the appointment. Please try again.', toastConfig)
      //  }
    } catch (error) {
      console.error('error while auto-scheduling', error)
      setSignLoaderModel(false)
    }

    if (setDataId) {
      let setUpID = setDataId ? setDataId.toString() : patientTreatments[noteID] && patientTreatments[noteID]?.id
      await addNoteDeatilsInLs('UPDATE', patientID.toString(), setDataId ? setDataId.toString() : setUpID.toString(), formattedJson, getFormattedDate().toString(), 'Signed', 'true', appointmentId, patientData)
      toast.success('Successfully Signed', toastConfig)
    } else {
      // await PatientDataCRUD('INSERT', patientID.toString(), '', formattedJson, getFormattedDate().toString(), 'Signed', 'true')
      handleInsertData()
      toast.success('Successfully Signed', toastConfig)
    }

    await GetPatientTreatmentsNotes()
    setModalVisible(false)
    setIsAckChecked(false)
    setSignLoaderModel(false)
  }

  const handleAddMorseCodeOffline = async (updatedScore, updatedDate, diagnosisName, scoreType) => {
    let dataOffline = await getTestOfflineData()
    if (dataOffline) {
      dataOffline = {
        ...dataOffline,
        [loggedUserProvider?.ID]: {
          ...dataOffline[loggedUserProvider?.ID],
          [patientID]: {
            ...dataOffline[loggedUserProvider?.ID][patientID],
            currentNote: {
              ...dataOffline[loggedUserProvider?.ID][patientID].currentNote,
              data: {
                ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data,
                [scoreType]: {
                  ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data[scoreType],
                  [diagnosisName]: {
                    date: updatedDate,
                    score: updatedScore,
                  },
                },
                assessment: {
                  ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data.assessment,
                  [diagnosisName]: {
                    ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data.assessment[diagnosisName],
                    ['MorseScore']: {
                      date: updatedDate,
                      score: updatedScore,
                    },
                  },
                },
              },
            },
          },
        },
      }
    }
    await saveTestOfflineData(dataOffline)
  }

  const updateNoteStructure = (updatedScore, updatedDate, diagnosisName, scoreType) => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      [scoreType]: {
        ...noteStructureRef.current[scoreType],
        [diagnosisName]: {
          date: updatedDate,
          score: updatedScore,
        },
      },
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          ['MorseScore']: {
            date: updatedDate,
            score: updatedScore,
          },
        },
      },
    }
    handleAddMorseCodeOffline(updatedScore, updatedDate, diagnosisName, scoreType)
  }

  const submitTreatsShell = () => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
    }

    setModalVisible(true)
  }

  const showOnlyNoteDiagnosis = async () => {
    const diagnosisIds = noteStructureRef.current?.metadata?.diagnosisIds
    // let offlineData = await getTestOfflineData()
    // let providerDetails = await getProviderDetails()

    // const providerId = providerDetails?.ID
    // const diagnosisIds = offlineData?.[providerId]?.[patientID]?.currentNote?.data?.metadata?.diagnosisIds || []
    if (Array.isArray(diagnosisIds) && diagnosisIds.length > 0) {
      try {
        // let response = await GetDiagnosisData('')
        // response = JSON.parse(response.d)?.Data

        let response = await getAllMasterDiagnosis()
        response = response?.Data

        const filteredNoteDiagnosis = response?.filter((item) => diagnosisIds.includes(item.id))

        if (filteredNoteDiagnosis?.length > 0) {
          setPatientDiagnosis(filteredNoteDiagnosis.map((item) => item.Name))
        } else {
          setPatientDiagnosis([])
        }
      } catch (error) {
        setPatientDiagnosis([])
      }
    } else {
      setPatientDiagnosis([])
    }
  }

  //
  const carryForwardData = async () => {
    if (!creatingNewNote) return
    const dataResponse = await PatientNoteDataCRUD('GET', patientID)
    const parsedData = JSON.parse(dataResponse?.d)?.Data
    const allNotes = parsedData.map((item) => ({
      ...item,
      data: item?.data ? JSON.parse(item?.data) : {},
    }))
    if (allNotes.length <= 1) return
    const lastNoteIndex = allNotes.length - 2 // get your prev data of added
    const newNoteIndex = allNotes.length - 1 // get your this note data of added
    const lastAddedNote = allNotes[lastNoteIndex]
    const newlyAddedNote = allNotes[newNoteIndex]
    const dataLastNote = lastAddedNote?.data
    let patientDiagnosisInLastNote
    const diagnosisIds = dataLastNote?.metadata?.diagnosisIds
    if (Array.isArray(diagnosisIds) && diagnosisIds.length > 0) {
      // let response = await GetDiagnosisData('')
      // response = JSON.parse(response.d)?.Data
      let response = await getAllMasterDiagnosis()
      response = response?.Data
      const filteredNoteDiagnosis = response?.filter((item) => diagnosisIds.includes(item.id))
      if (filteredNoteDiagnosis?.length > 0) {
        patientDiagnosisInLastNote = filteredNoteDiagnosis.map((item) => item.Name)
      }
    }
    const previousRiskFactors = dataLastNote?.riskFactors || {}
    const previousDDX = dataLastNote?.patientDifferentialDiagnosis || {}
    const previousAlert = dataLastNote?.alertData || {}
    const previousHistoryOfDiagnosis = dataLastNote?.historyOfDiagnosis || {}
    // Temporary object to hold only the relevant data
    const carryForwardObject = {
      historyOfDiagnosis: {},
      riskFactors: {},
      metadata: {
        diagnosisIds: dataLastNote?.metadata?.diagnosisIds || [],
      },
      patientDifferentialDiagnosis: {},
      alertData: {},
    }
    patientDiagnosisInLastNote.filter(Boolean).forEach((diagnosis) => {
      const cleanedDiagnosis = diagnosis
      if (previousRiskFactors[cleanedDiagnosis]) {
        carryForwardObject.riskFactors[cleanedDiagnosis] = previousRiskFactors[cleanedDiagnosis]
        setSelectedRisks((prev) => ({
          ...prev,
          [cleanedDiagnosis]: previousRiskFactors[cleanedDiagnosis],
        }))
      }
      if (previousDDX[cleanedDiagnosis]) {
        carryForwardObject.patientDifferentialDiagnosis[cleanedDiagnosis] = previousDDX[cleanedDiagnosis]
      }
      if (previousAlert[cleanedDiagnosis]) {
        carryForwardObject.alertData[cleanedDiagnosis] = previousAlert[cleanedDiagnosis]
      }
      if (previousHistoryOfDiagnosis[cleanedDiagnosis]) {
        carryForwardObject.historyOfDiagnosis[cleanedDiagnosis] = previousHistoryOfDiagnosis[cleanedDiagnosis]
      }
    })
    noteStructureRef.current = {
      ...noteStructureRef.current,
      historyOfDiagnosis: carryForwardObject.historyOfDiagnosis,
      isCarryForward: true,
      riskFactors: carryForwardObject.riskFactors,
      patientDifferentialDiagnosis: carryForwardObject.patientDifferentialDiagnosis,
      metadata: {
        ...noteStructureRef.current.metadata,
        diagnosisIds: carryForwardObject.metadata.diagnosisIds,
      },
      alertData: carryForwardObject.alertData,
    }
    await PatientNoteDataCRUD('UPDATE', patientID.toString(), newlyAddedNote?.id.toString(), JSON.stringify(noteStructureRef.current), getFormattedDate().toString(), 'Draft', false)
    await showOnlyNoteDiagnosis()
  }

  useEffect(() => {
    carryForwardData()
  }, [])

  useEffect(() => {
    showOnlyNoteDiagnosis()
  }, [noteStructureRef.current?.metadata])

  const handleOrderFlag = () => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      orderProviderFlag: false,
    }
    setShowOrderPopUp(false)
  }

  // const addDiagnosisIdsToNote = async (ids) => {
  //   const existingIds = noteStructureRef.current?.metadata?.diagnosisIds || []
  //   const tempIds = noteStructureRef.current?.metadata?.tempIds || []
  //   const combinedIds = [...existingIds, ...ids]
  //   const combinedTempIds = [...tempIds, ...ids]
  //   const uniqueTempIds = Array.from(new Set(combinedTempIds))
  //   const uniqueIds = Array.from(new Set(combinedIds))

  //   noteStructureRef.current = {
  //     ...noteStructureRef.current,
  //     metadata: {
  //       ...noteStructureRef.current.metadata,
  //       diagnosisIds: uniqueIds,
  //       tempIds: uniqueTempIds,
  //     },
  //   }

  //   await saveTreatsShell(false)
  // }

  const handleAddDiagnosisOfflineIdsToNote = async (uniqueIds, tempIds) => {
    let dataOffline = await getTestOfflineData()
    if (dataOffline) {
      dataOffline = {
        ...dataOffline,
        [loggedUserProvider?.ID]: {
          ...dataOffline[loggedUserProvider?.ID],
          [patientID]: {
            ...dataOffline[loggedUserProvider?.ID][patientID],
            currentNote: {
              ...dataOffline[loggedUserProvider?.ID][patientID].currentNote,
              data: {
                ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data,
                metadata: {
                  ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data.metadata,
                  diagnosisIds: uniqueIds,
                  tempIds: tempIds,
                },
              },
            },
          },
        },
      }
      await saveTestOfflineData(dataOffline)
    }
  }

  const addDiagnosisIdsToNote = async (ids, infoText = '') => {
    ids.forEach((id) => {
      const diagnosis = MasterDiagnosisData.find((d) => d.id === id)

      if (diagnosis) {
        const key = diagnosis.Name.trim()
        const existingData = noteStructureRef.current?.information?.[key] || []

        if (!existingData.includes(infoText || 'Added from provider')) {
          noteStructureRef.current.information = {
            ...noteStructureRef.current.information,
            [key]: [...existingData, infoText || 'Added from provider'],
          }
        }
      }
    })

    const existingIds = noteStructureRef.current?.metadata?.diagnosisIds || []
    const tempIds = noteStructureRef.current?.metadata?.tempIds || []

    const newTempIds = ids.filter((id) => !existingIds.includes(id))

    const combinedIds = [...existingIds, ...ids]
    const combinedTempIds = [...tempIds, ...newTempIds]

    const uniqueIds = Array.from(new Set(combinedIds))
    const uniqueTempIds = Array.from(new Set(combinedTempIds))

    noteStructureRef.current = {
      ...noteStructureRef.current,
      metadata: {
        ...noteStructureRef.current.metadata,
        diagnosisIds: uniqueIds,
        tempIds: uniqueTempIds,
      },
    }
    await handleAddDiagnosisOfflineIdsToNote(uniqueIds, uniqueTempIds)

    // await saveTreatsShell(false)
  }

  // use it when you get the diagnosis in showonlydiagnosisfornote this is offline one

  // const addDiagnosisIdsToNote = async (ids, infoText = '') => {

  //     let offlineData = await getTestOfflineData()
  //     let providerDetails = await getProviderDetails()
  //     const providerId = providerDetails?.ID
  //     let patientNote = offlineData?.[providerId]?.[patientID]?.currentNote?.data
  //   ids.forEach(async(id) => {
  //     const diagnosis = MasterDiagnosisData.find((d) => d.id === id)
  //     if (diagnosis) {
  //       const key = diagnosis.Name.trim()
  //       const existingData = patientNote?.information?.[key] || []

  //       if (!existingData.includes(infoText || 'Added from provider')) {
  //         patientNote.information = {
  //           ...patientNote.information,
  //           [key]: [...existingData, infoText || 'Added from provider'],
  //         }
  //       }
  //     }
  //   })

  //   const existingIds = noteStructureRef.current?.metadata?.diagnosisIds || []
  //   const tempIds = noteStructureRef.current?.metadata?.tempIds || []

  //   const newTempIds = ids.filter((id) => !existingIds.includes(id))

  //   const combinedIds = [...existingIds, ...ids]
  //   const combinedTempIds = [...tempIds, ...newTempIds]

  //   const uniqueIds = Array.from(new Set(combinedIds))
  //   const uniqueTempIds = Array.from(new Set(combinedTempIds))

  //   patientNote = {
  //     ...patientNote,
  //     metadata: {
  //       ...patientNote.metadata,
  //       diagnosisIds: uniqueIds,
  //       tempIds: uniqueTempIds,
  //     },
  //   }

  //   // noteStructureRef.current = {
  //   //   ...noteStructureRef.current,
  //   //   metadata: {
  //   //     ...noteStructureRef.current.metadata,
  //   //     diagnosisIds: uniqueIds,
  //   //     tempIds: uniqueTempIds,
  //   //   },
  //   // }

  //   offlineData[providerId][patientID].currentNote.data = patientNote

  //   await saveTestOfflineData(offlineData)
  //   // await saveTreatsShell(false)
  //   await showOnlyNoteDiagnosis()
  // }

  const fetchAddendumData = async () => {
    try {
      let data = await SaveExtra('Get_By_Type', 'Addendum', '', '')

      data = JSON.parse(data?.d)?.Data || []

      data = data.map((item) => JSON.parse(item?.JsonData))
      data = data.reverse() // latest first

      const currentNoteID = noteID.toString()
      const noteIDNum = parseInt(noteID, 10)
      const previousNoteID = noteIDNum > 0 ? (noteIDNum - 1).toString() : null

      const findPatientNoteData = (data, patientID, noteID) => {
        for (let i = 0; i < data.length; i++) {
          const item = data[i]

          if (item[patientID]) {
            if (item[patientID][currentNoteID]) {
              return item[patientID][currentNoteID]
            }

            // if (previousNoteID && item[patientID][previousNoteID]) {
            //     return item[patientID][previousNoteID];
            // }
          }
        }
        return null
      }

      const result = findPatientNoteData(data, patientID, noteID)
      if (result) {
        setAddendum(result)
      } else {
        const searchNotes = noteIDNum > 0 ? `${noteID} or ${noteIDNum - 1}` : noteID
        console.warn(`Patient ${patientID} with note ${searchNotes} not found`)
        setAddendum(null)
      }
    } catch (error) {
      console.error('Failed to fetch addendum data:', error)
      setAddendum(null)
    }
  }

  const fetchPastOrders = async () => {
    try {
      let data = await PatientOrdersCRUD('Get', '', patientID)

      data = JSON.parse(data?.d).Data || []

      const parsedOrders = data
        ?.map((order) => ({
          id: order.id,
          date: order.date,
          medication: JSON.parse(order.medication),
        }))
        .filter((item) => item.medication?.noteID === parseInt(noteID) - 1)

      setPastOrders(parsedOrders)

      setShowOrderPopUpYN(parsedOrders?.length === 0 ? false : true)
    } catch (error) {
      console.error('Failed to fetch or parse orders:', error)
    }
  }

  const fetchCurrentOrders = async () => {
    try {
      let data = await PatientOrdersCRUD('Get', '', patientID)

      data = JSON.parse(data?.d).Data || []

      const parsedOrders = data
        ?.map((order) => ({
          id: order.id,
          date: order.date,
          medication: JSON.parse(order.medication),
        }))
        .filter((item) => item.medication?.noteID === parseInt(noteID))

      setCurrentOrder(parsedOrders)
    } catch (error) {
      console.error('Failed to fetch or parse orders:', error)
    }
  }

  useEffect(() => {
    fetchAddendumData()
    fetchCurrentOrders()
    fetchPastOrders()
  }, [noteID])

  const [AddHistoryToggle, setAddHistoryToggle] = useState(false)
  const handleAddHistoryToggle = () => {
    setAddHistoryToggle((prev) => !prev)
  }

  const [superBillForNote, setSuperBillForNote] = useState(null)

  const getSuperbillForthisnote = async () => {
    // let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', patientData?.PatientID.toString())
    // data = JSON.parse(data?.d)?.Data || []

    let data = patientDBData?.patientSuperBill

    if (data?.length > 0) {
      data = data.map((item) => ({
        ...item,
        JsonData: item?.JsonData ? JSON.parse(item.JsonData) : {},
      }))
    }

    const findBillForThisNote = data.find((item) => item?.JsonData?.noteID === noteID)

    setSuperBillForNote(findBillForThisNote)
  }

  const pathname = window.location.pathname // e.g. "/home/provider/completed-appointment"
  const segments = pathname.split('/').filter(Boolean) // removes empty strings

  // Join the first 3 segments
  const baseRoute = segments.slice(0, 3).join('/')

  //  code for auto scheduled

  const [daysMap, setDaysMap] = useState({})
  const [locations, setLocations] = useState([])
  const getFacilitiesAppointment = async () => {
    let facilities = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(facilities.d)

    facilities = data.Data
    facilities = facilities.filter((obj) => {
      if (obj.Days && obj.Days != '') {
        return obj
      }
    })
    setLocations(facilities)
  }

  const getSuperBillData = async (patientID) => {
    try {
      let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', patientID.toString())
      data = JSON.parse(data?.d)?.Data || []

      if (data?.length) {
        data = data.map((item) => ({
          Id: item.Id,
          Data: JSON.parse(item?.JsonData),
        }))
      }

      const lastItem = data?.at(-1)?.Data?.followUpTime ?? null

      // setScheduleTime(lastItem)
      return lastItem
    } catch (error) {
      console.error('Error fetching Super Bill data:', error)
    }
  }

  const getAllProviderDetails = async (obj) => {
    try {
      const provider = {
        ID: obj.ID,
      }

      let providerData = await fetchPatientData('SELECTALL', 'Provider', JSON.stringify(provider))

      let insuranceData = JSON.parse(providerData.d)?.Insurance
      let facilityData = JSON.parse(providerData.d)?.Facility

      obj['Insurances'] = insuranceData
      obj['Facilities'] = facilityData

      return obj
    } catch (error) {
      console.error('Error fetching provider details:', error)
      return obj // Optional: return the original object in case of failure
    }
  }

  const getProviders = async () => {
    // let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
    // let data = JSON.parse(providerData.d)

    let data = await getProviderList()

    let providerData = data

    let newProviders = []
    // for (let i = 0; i < providerData.length; i++) {
    //   let c = await getAllProviderDetails(providerData[i])
    //   newProviders.push(c)
    // }

    const daysMap = {}
    const allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

    // newProviders.forEach((provider) => {
    providerData.forEach((provider) => {
      let parsedCapacity = null
      try {
        if (provider?.ProviderData && provider.ProviderData !== 'undefined') {
          parsedCapacity = JSON.parse(provider.ProviderData)
        }
      } catch (error) {
        console.error('Invalid JSON in ProviderData:', provider.ProviderData, error)
        parsedCapacity = null
      }

      allDays.forEach((day) => {
        if (!daysMap[day]) daysMap[day] = []

        let providerEntry = daysMap[day].find((p) => p.ID === provider.ID)

        if (!providerEntry) {
          providerEntry = {
            ID: provider.ID,
            Name: provider.Name,
            Gender: provider.Gender,
            DOB: provider.DOB,
            Address: provider.Address,
            AddressDetails: provider.AddressDetails,
            Lat: provider.Lat,
            Lng: provider.Lng,
            Insurances: provider.Insurances,
            Facilities: [],
            Capacity: parsedCapacity,
          }
          daysMap[day].push(providerEntry)
        }

        provider.Facilities.forEach((facility) => {
          providerEntry.Facilities.push(facility)
        })
      })
    })

    setDaysMap(daysMap)
    return providerData
  }

  const allData = useRef({})

  function formatDate(date) {
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    const yyyy = String(date.getFullYear())
    const hh = String(date.getHours()).padStart(2, '0')
    const min = String(date.getMinutes()).padStart(2, '0')
    return `${mm}/${dd}/${yyyy} ${hh}:${min}`
  }

  const handleUpdatePatientStatus = async (customData) => {
    try {
      let a = {}
      let facility = await patientSelectedFacility(customData)

      try {
        a['FacilityID'] = facility?.value.toString() || selectedFacility?.value.toString()
        a['FacilityName'] = facility?.label.toString() || selectedFacility?.label.toString()
        a['Room'] = customData?.Room?.toString() || roomNumber.toString()
      } catch (e) {
        a['FacilityID'] = ''
        a['FacilityName'] = ''
        a['Room'] = -1
      }

      const updateStatus = {
        ...customData,
        Status: 'Follow Up',
      }

      // let allDiagnosis = allSelectedDiagnosis.map(obj => { return obj.label }).join(",");

      let allDiagnosis = customData?.Diagnosis || ''

      let insurances = addedInsurances.map((ins) => ({
        InsuranceID: ins?.ID,
      }))
      let savePatientInfo
      if (updateStatus?.PatientID && updateStatus?.PatientID !== '') {
        savePatientInfo = SavePatients('Update', JSON.stringify(updateStatus), JSON.stringify(a), allDiagnosis, updateStatus?.PatientID, JSON.stringify(insurances))
      } else {
        console.log('patientId Not Found', updateStatus)
      }

      await savePatientInfo

      await patientDataFn()
    } catch (error) {
      console.log('error while updating patient Status', error)
    }
    // resetStates()
  }

  const handleAppointmentSubmit = async (appointmentID, patient) => {
    try {
      // setIsPageLoading(true)
      // const ChangeNoteStatus = handlePatientNote('Finished', appointmentID, patientId)
      const updatePaitent = await handleUpdatePatientStatus(patient)
      const appointmentData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)
      const appointment = appointmentData.length > 0 ? appointmentData[0] : []
      const groupedData = []
      let latestData
      if (appointmentData.length > 0) {
        latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value)
      } else {
        toast.error('No data found', appointmentData)
        return false
      }

      let appointmentFilterData = latestData.map((item) => {
        if (item.data.AppointmentID === appointmentID) {
          const now = new Date()
          const formattedEndDate = now
            .toLocaleString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })
            .replace(',', '')
          return {
            ...item,
            data: {
              ...item.data,
              Status: 'Signed',
              EndTimezone: formattedEndDate,
            },
          }
        }
        return item
      })

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })
      const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value)

      if (ID) {
        await PatientAppointmentDetails('UPDATE', ID, appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value, JSON.stringify(groupedData))
        return true
      } else {
        toast.error('Appointment ID note found', toastConfig)
        return false
      }
    } catch (error) {
      toast.error('Failed to save', toastConfig)
      return false
    }
  }

  const handleSchedule = async (props, patient, oldData) => {
    if (!props?.StartTime || !props?.EndTime) return

    try {
      let scheduleAppointmentTime = await getSuperBillData(patient.PatientID)

      const weeksMatch = scheduleAppointmentTime?.match(/(\d+)\s*week/i)
      const weeksToAdd = weeksMatch ? parseInt(weeksMatch[1], 10) : 1

      let startTime = new Date(props.StartTime)
      let targetDate = new Date(startTime)
      targetDate.setDate(targetDate.getDate() + weeksToAdd * 7)

      const dayOptions = { weekday: 'long' }
      const day = targetDate.toLocaleDateString('en-US', dayOptions)

      const allDayData = daysMap[day]

      if (!allDayData) {
        console.warn(`No data found for ${day}.`)
        alert('No schedule available for this day.')
        return
      }

      allDayData.forEach((obj) => {
        obj.Facilities.forEach((facility) => {
          let tempFacility = locations.find((o) => o.ID == facility.FacilityID)
          facility['Name'] = tempFacility?.Name || ''
          facility['Type'] = tempFacility?.Type || ''
        })
      })

      const providerInfo = allDayData.filter((obj) => obj.Facilities.some((facility) => facility.Name === patient.FacilityName))

      if (providerInfo.length === 0) {
        console.warn(`No provider assigned to ${patient.FacilityName} on ${day}.`)
        alert(`No providers are currently assigned to ${patient.FacilityName} on ${day}.`)
        return
      }

      let provider = providerInfo.find((item) => item?.ID === oldData?.current?.Provider?.value)
      if (!provider) provider = providerInfo[0]

      allData.current.Provider = {
        value: provider?.ID,
        label: provider?.Name,
      }

      return targetDate
    } catch (e) {
      console.error('Error processing schedule:', e)
    }
  }

  const handleAutoSchedule = async (item, appointmentID) => {
    const appointmentFilterData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)
    let patientInsurance = await PatientInsuranceFn('SELECT', '', item.PatientID)
    let tempAppointments = []
    let Insurance = {}
    try {
      patientInsurance = JSON.parse(patientInsurance.d)?.Data
      if (patientInsurance.length > 0) {
        Insurance = JSON.parse(patientInsurance[0].InsuranceDetails)
        Insurance = Insurance[0] || {}
      }
    } catch (e) {}
    try {
      let getPatientTime = await PatientNoteDataCRUD('GET', item.PatientID)
      getPatientTime = JSON.parse(getPatientTime.d)?.Data
      getPatientTime = getPatientTime.map((entry) => ({
        ...entry,
        getPatientTime: entry.getPatientTime ? JSON.parse(entry.getPatientTime) : {},
      }))
      if (getPatientTime) {
        let rawDate = getPatientTime.length > 0 ? getPatientTime[0].date : new Date().toISOString().split('T')[0]
        let formattedDate = rawDate.replaceAll('.', '/')

        let props = {
          StartTime: appointmentFilterData.length > 0 ? appointmentFilterData[0]?.data.StartTime : formattedDate,
          EndTime: formattedDate,
          PatientID: item.PatientID,
        }

        // let filtered = await getAppointmentForAutoSchedule()
        let filtered = await getAllAppointments('GET')
        // let filtered await PatientAppointmentDetails('UPDATE', ID, selectDate, providerID, JSON.stringify(groupedData))

        let oldData
        if (filtered.length > 0) {
          filtered = filtered.filter((entry) => entry.patientID === item.PatientID && entry.appointmentDetails.some((appt) => appt.data?.Status === 'Signed' || appt.data?.Status === 'Finish'))
          oldData = filtered[0]?.appointmentDetails?.at(-1)
        }

        if (oldData?.data?.isInFacility === false) {
          alert(`Patient ${item.FirstName} ${item.LastName || ''} is not in the facility and cannot be scheduled.`)
          return
        }
        let updateOtherDetails = {}

        const priorAuth = oldData?.data?.otherDetails?.priorAuth
        if (priorAuth?.isRequired) {
          let noOfTimes = parseInt(priorAuth?.details?.noOfTimes, 10)

          if (isNaN(noOfTimes) || noOfTimes <= 0) {
            alert(`Patient ${item.FirstName} ${item.LastName || ''} has no remaining prior auth and cannot be scheduled.`)
            if (oldData?.data) {
              oldData.data.isInFacility = false
            }
            return
          } else {
            updateOtherDetails = {
              ...oldData.data.otherDetails,
              priorAuth: {
                ...priorAuth,
                details: {
                  ...priorAuth.details,
                  noOfTimes: `${noOfTimes - 1}`,
                },
              },
            }
          }
        }

        let scheduledDate = await handleSchedule(props, item, oldData)
        let organizeDate = formatDate(scheduledDate)

        let facility = locations?.find((facility) => facility.Name === item.FacilityName)

        let localPatient = { value: item.PatientID, label: `${item.FirstName} ${item.LastName}` }
        let localFacility = { value: facility?.ID, label: facility?.Name }
        let localProvider = allData.current?.Provider || {}

        let data = {
          AppointmentName: `${item.FirstName} ${item.LastName}`,
          StartTime: organizeDate,
          EndTime: organizeDate.replace(':00', ':15').replace(':30', ':45'),
          PatientID: item.PatientID,
          StartTimezone: null,
          EndTimezone: null,
          Facility: facility?.Name || '',
          Insurance: Insurance || {},
          Status: 'Scheduled',
          Notes: '',
          RoomNumber: item.Room,
          RecurrenceRule: '',
          VisitReason: 'F/U (Follow Up)',
          isInFacility: oldData ? oldData?.data?.isInFacility || true : true,
          otherDetails: oldData ? updateOtherDetails || {} : {},
          AppointmentID: Date.now(),
          ProviderName: localProvider?.label || '',
          ScheduleBy: 'auto-manuel',

          // PatientStatus: filtered.length > 0 ? 'Follow Up' :  item?.Status || 'NewPatient'
          Type: 'Follow Up',
          CreatedDate: new Date(),
          patientSeen: oldData ? oldData?.data?.patientSeen : true,
          notSeenReason: oldData ? oldData?.data?.notSeenReason : '',
          customReason: oldData ? oldData?.data?.customReason : '',

          // isDragged: oldData ? (oldData?.data?.isDragged || false) : false,
        }

        let details = {
          data,
          current: {
            Patient: localPatient,
            Facility: localFacility,
            Provider: localProvider,
            Insurance: Insurance,
          },
        }

        tempAppointments.push(details)
      } else {
        alert('Patient creation failed: Patient creation date not found. \n Hint: Try using manual-schedule to proceed.')
      }
    } catch (error) {
      console.error('Error fetching patient orders', error)
    }
    if (tempAppointments.length > 0) {
      const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', tempAppointments[0].data.StartTime.split(' ')[0], tempAppointments[0]?.current?.Provider?.value)
      const apiCallType = latestData.length > 0 ? 'UPDATE' : 'INSERT'
      const combinedAppointments = [...latestData, ...tempAppointments]

      handleSubmit(combinedAppointments, apiCallType, tempAppointments[0])
    }
  }

  const handleSubmit = async (updateData, apiCallType, selectedAppointments, type = null) => {
    try {
      // setIsPageLoading(true)

      const groupedData = []

      updateData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      const appointmentData = selectedAppointments
      if (apiCallType == 'UPDATE') {
        const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', appointmentData?.data?.StartTime.split(' ')[0], appointmentData?.current?.Provider?.value)
        await PatientAppointmentDetails('UPDATE', ID, appointmentData?.data?.StartTime.split(' ')[0], appointmentData?.current?.Provider?.value, JSON.stringify(groupedData))
      } else {
        await PatientAppointmentDetails('INSERT', '', appointmentData?.data?.StartTime.split(' ')[0], appointmentData?.current?.Provider?.value, JSON.stringify(groupedData))
      }

      if (type == 'Rescheduled') {
        toast.success('Patient Rescheduled Scheduled  Successfully', toastConfig)
      } else {
        toast.success('Patient Auto Scheduled  Successfully', toastConfig)
      }
    } catch (error) {
      toast.error('Failed to Auto Scheduled', toastConfig)
      // setIsPageLoading(false)
    }
  }

  const [facility, setFacility] = useState({
    facility: '',
    roomNumber: '',
  })

  const [patinetWithFacilityData, setPatinetWithFacilityData] = useState(null)
  const [editModalVisible, setEditModalVisible] = useState(false)
  const [creatingPatientLoader, setCreatingPatientLoader] = useState(false)

  const handleEditPatient = (rowSelected) => {
    setFacility((prev) => ({
      ...prev,
      facility: rowSelected?.FacilityName,
      roomNumber: rowSelected?.Room,
    }))
    const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)
    setPatinetWithFacilityData(userFacilities)
    setPatientID(rowSelected?.PatientID)
    setChildFormData({
      FirstName: rowSelected?.FirstName || '',
      MiddleName: rowSelected?.MiddleName || '',
      LastName: rowSelected?.LastName || '',
      DOB: rowSelected?.DOB || '',
      Gender: rowSelected?.Gender || '',
      Age: rowSelected?.Age || '0',
      PhoneNumber: rowSelected?.PhoneNumber || '',
      EmergencyName: rowSelected?.EmergencyName || '',
      EmergencyPhone: rowSelected?.EmergencyPhone || '',
      Address: rowSelected?.Address || '',
      State: rowSelected?.State || '',
      City: rowSelected?.City || '',
      ZipCode: rowSelected?.ZipCode || '',
      Country: rowSelected?.Country || '',
      Status: rowSelected?.Status || '',
    })
    setEditModalVisible(true)
  }
  const updatePatientMasterData = async (patientID, patientEditData) => {
    const patientData = await getPatientDetails()
    const parsedEditData = JSON.parse(patientEditData)
    const updatedPatients = patientData.map((item) => {
      if (item.PatientID === patientID) {
        return {
          ...item,
          ...parsedEditData,
          Room: facility?.roomNumber,
        }
      }
      return item
    })

    await savePatientDetails(updatedPatients)
  }

  const addPatientEditData = async (patientEditData, facility, patientID, insurance) => {
    const data = await getTestOfflineData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }
    const newlyAddedData = patientData.newlyAddedData || []

    await updatePatientMasterData(patientID, patientEditData)
    const editPatinet = {
      MODE: 'UPDATE',
      data: patientEditData,
      facility: facility,
      patientID: patientID,
      insurance: insurance,
    }

    const updatedPatientData = {
      ...patientData,
      newlyAddedData: { ...newlyAddedData, patientEditData: editPatinet },
    }

    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }

    await saveTestOfflineData(updatedData)
    // setPatientDBData(updatedPatientData)
  }

  const handleEditPatinetSubmit = async () => {
    setCreatingPatientLoader(true)
    try {
      let a = {
        FacilityID: patinetWithFacilityData?.value?.toString() || '',
        FacilityName: patinetWithFacilityData?.label?.toString() || '',
        Room: facility?.roomNumber || -1,
      }

      let insurances = addedInsurances.map((ins) => ({
        InsuranceID: ins?.ID,
      }))
      let savePatientInfo
      if (patientID && patientID !== '') {
        setFacility((prev) => ({
          ...prev,
          facility: a?.FacilityName,
          roomNumber: a?.Room,
        }))
        await addPatientEditData(JSON.stringify(childformData), JSON.stringify(a), patientID, JSON.stringify(insurances))
        // savePatientInfo = SavePatients('Update', JSON.stringify(childformData), JSON.stringify(a), '', patientID, JSON.stringify(insurances))
      }

      // await savePatientInfo
      //  await patientDataFn(patientID)
      //  await fetchPatientDataFn(patientID)
      setTimeout(async () => {
        await fetchPatientDataFn(patientID)
      }, 1000)
      resetStates()
      setPatinetWithFacilityData({})
    } catch (error) {
      console.error('Error while editing patient:', error)
      // optional: show toast or alert
      // toast.error("Something went wrong while saving patient")
    } finally {
      setCreatingPatientLoader(false)
    }
  }

  useEffect(() => {
    getProviders()
    getFacilitiesAppointment()
  }, [])

  //// DB ALL Data

  const getPatientInternalNotes = async () => {
    setNotes(patientDBData?.interNote || [])
    return patientDBData.interNote || []
  }

  useEffect(() => {
    getPatientInternalNotes()
    getSuperbillForthisnote()
  }, [patientDBData])

  return (
    <>
      {isPatientPageLoading ? (
        <div className="" style={{ height: '100vh', background: '#fff', width: '100%' }}>
          <Loader />
        </div>
      ) : (
        <div className="#0E0E0E">
          <div className="d-flex align-items-center justify-content-between gap-4">
            <div>
              <CBreadcrumb>
                <CBreadcrumbItem
                  href={
                    baseRoute === 'home/provider/appointment'
                      ? '/home/provider/appointment'
                      : baseRoute === '/home/provider/today-appointment'
                        ? '/home/provider/today-appointment'
                        : baseRoute === 'home/provider/test-appointment'
                          ? '/home/provider/test-appointment'
                          : '/home/provider/today-appointment'
                  }
                >
                  <span className="text-white">Home</span>
                </CBreadcrumbItem>
                <CBreadcrumbItem active>Test Patients</CBreadcrumbItem>
              </CBreadcrumb>
            </div>

            <div className="d-flex text-center align-items-center gap-4">
              <p
                className="p-0 m1"
                style={{
                  left: '-40px',
                  fontWeight: 600,
                  fontSize: '20px',
                }}
              >
                {patientData?.FirstName + ' ' + patientData?.LastName} {patientData?.Age || patientData?.Gender ? `(${patientData?.Age ? patientData?.Age : ''}${patientData?.Age && patientData?.Gender ? '-' : ''}${patientData?.Gender ? patientData?.Gender : ''})` : ''} {patientData?.Room}
                <span style={{ cursor: 'pointer' }} onClick={() => handleEditPatient(patientData)}>
                  {' '}
                  <Pencil size={17} />{' '}
                </span>
              </p>
            </div>
            <div className="patient-header-free" style={{}}></div>
          </div>

          {showAllData && (
            <CRow className="auto" style={{ border: '2px solid red' }}>
              <div className="custom-tabs-wrapper position-relative">
                <CNav className="tabs-nav">
                  {navLinks.map((link, index) => (
                    <CNavItem key={index}>
                      <CNavLink
                        active={activeTab === link.tab}
                        onClick={() => handleTabClick(link.tab)}
                        href="#"
                        style={{
                          minWidth: '70px',
                          height: '70px',
                          borderRadius: '50%',
                          backgroundColor: '#1e1e1e',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',

                          borderBottom: activeTab === link.tab ? '1px solid #888' : '1px solid transparent',
                          boxShadow: activeTab === link.tab ? '0 4px 6px -2px #666' : 'none',
                          flex: '0 0 auto',
                        }}
                      >
                        {link.title}
                      </CNavLink>
                    </CNavItem>
                  ))}
                </CNav>

                {patientDBData && (
                  <FloatingNotePreviewTest
                    hpiAdded={hpiAdded}
                    peAdded={peAdded}
                    setPEAdded={setPEAdded}
                    changesInTreatmentShell={changesInTreatmentShell}
                    setChangesInTreatmentShell={setChangesInTreatmentShell}
                    rosAdded={rosAdded}
                    setRosAdded={setRosAdded}
                    addedNewIncident={addedNewIncident}
                    setAddedNewIncident={setAddedNewIncident}
                    setHpiAdded={setHpiAdded}
                    patientID={patientID}
                    statusPatientNote={noteStatus || ''}
                    showHrsInTreatment={true}
                    setDataId={setDataId}
                    showTreatmentAsAccordion={true}
                    showComment={showComment}
                    submitNotes={submitNotes}
                    setModalVisible={setModalVisible}
                    formData={patientData}
                    diagnosis={diagnosisData}
                    diagnosisCode={diagnosisCode}
                    noteStructureRef={noteStructureRef}
                    selectedRisks={selectedRisks}
                    setSelectedRisks={setSelectedRisks}
                    selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                    setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                    hospitalRecords={allHistory}
                    setHospitalRecords={setAllHistory}
                    medication={medicationList}
                    setMedication={setMedicationList}
                    patientTreatments={patientTreatments}
                    newImagingAdded={newImagingAdded}
                    newLabsAdded={newLabsAdded}
                    newmedsAdded={newmedsAdded}
                    diagnosisAddedPinger={diagnosisAddedPinger}
                    allergies={allergiesList}
                    setAllergies={setAllergiesList}
                    patientDiagnosis={patientDiagnosis}
                    MasterDiagnosisData={MasterDiagnosisData}
                    imagingTypeList={imagingTypeList}
                    imaging={imagingList}
                    setImaging={setImagingList}
                    activeTab={historyPersonalHistoryActiveTab}
                    setActiveTab={setHistoryPersonalHistoryActiveTab}
                    patientData={patientData}
                    patientSidebarActiveTab={activeTab}
                    personalHistory={histories}
                    setPersonalHistory={setHistories}
                    allLabs={allLabs}
                    noteID={noteID}
                    showMedicationLikeApp={true}
                    patientDBData={patientDBData}
                  />
                )}
              </div>
              <div className="d-flex gap-4">
                {/* <CCol xs="1" className="" style={{ width: '12.666667%' }}>
                  <div style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }} className="custom-no-scroll">
                    <CNav vertical type className="flex-column" variant="pills">
                      {navLinks.map((link, index) => (
                        <CNavItem key={index} className="mb-3">
                          <CNavLink active={activeTab === link.tab} onClick={() => handleTabClick(link.tab)} href="#">
                            {link.title}
                          </CNavLink>
                        </CNavItem>
                      ))}
                    </CNav>
                  </div>
                </CCol> */}

                <ProviderPatientFloatingButtonTest
                  superBillForNote={superBillForNote}
                  isProviderPage={true}
                  appointmentForthisPatientNotSeen={appointmentForthisPatient?.data?.patientSeen}
                  handleAddHistoryToggle={handleAddHistoryToggle}
                  showAddHistory={activeTab === 24}
                  addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                  handleToggleAddDiagnosis={() => {
                    setAddDiagnosisModalVisible((p) => !p)
                  }}
                  targetRef={targetRef}
                  toPDF={toPDF}
                  noteStructureRef={noteStructureRef}
                  saveTreatsShell={saveTreatsShell}
                  submitTreatsShell={submitTreatsShell}
                  setNoteView={setNoteView}
                  isProviderNote={true}
                  togglePoacFreetype={togglePoacFreetype}
                  setTogglePoacFreetype={setTogglePoacFreetype}
                  showAddPoac={activeTab === 23}
                />

                <CCol xs={12} className=" " style={{ height: '100vh' }}>
                  <CRow className="mb-3 ">
                    <CCard className=" " style={{ height: '90vh', overflow: 'auto', background: '#0E0E0E' }}>
                      <CCardBody className="  p-0 mt-1" style={{ background: '#0E0E0E' }}>
                        <div style={{ height: '100%', overflowY: 'auto', background: ' ' }}>
                          {activeTab === 0 && (
                            <div className="position-relative  ">
                              <ShowDemographics formData={patientData} diagnosis={diagnosisData}></ShowDemographics>
                            </div>
                          )}
                          {activeTab === 1 && (
                            <div className="position-relative">
                              <Summary setActiveTab={setActiveTab} vitalsList={vitalsList} patientData={patientData} />
                            </div>
                          )}
                          {activeTab === 21 && (
                            <div className="px-2">
                              <ProviderNotesBontTest noteStructureRef={noteStructureRef} saveTreatsShell={saveTreatsShell} patientID={patientID} loading={loading} setLoading={setLoading} Notes={Notes} setNotes={setNotes}></ProviderNotesBontTest>
                            </div>
                          )}

                          {activeTab === 23 && (
                            <div className={`  ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} px-2  `}>
                              <ProviderPoac
                                noteID={noteID}
                                patientTreatments={patientTreatments}
                                showOnlyNoteDiagnosis={showOnlyNoteDiagnosis}
                                patientDiagnosis={patientDiagnosis}
                                noteStructureRef={noteStructureRef}
                                saveTreatsShell={saveTreatsShell}
                                patientID={patientID}
                                loading={loading}
                                setLoading={setLoading}
                                Notes={Notes}
                                setNotes={setNotes}
                                togglePoacFreetype={togglePoacFreetype}
                                setTogglePoacFreetype={setTogglePoacFreetype}
                              ></ProviderPoac>
                            </div>
                          )}
                          {activeTab === 2 && (
                            <div className="position-relative">
                              <PatientHistoryForm
                                saveTreatsShell={saveTreatsShell}
                                allHistory={allHistory}
                                setDiagnosisAddedPinger={setDiagnosisAddedPinger}
                                getHistory={getHistory}
                                setAllHistory={setAllHistory}
                                patientID={patientID}
                                loading={loading}
                                setLoading={setLoading}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                noteStructureRef={noteStructureRef}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                              ></PatientHistoryForm>
                            </div>
                          )}
                          {activeTab === 3 && (
                            <div className="position-relative">
                              <PatientPersonalHistory
                                saveTreatsShell={saveTreatsShell}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                setDiagnosisAddedPinger={setDiagnosisAddedPinger}
                                activeTab={historyPersonalHistoryActiveTab}
                                setActiveTab={setHistoryPersonalHistoryActiveTab}
                                patientID={patientID}
                                histories={histories}
                                setHistories={setHistories}
                                loading={loading}
                                setLoading={setLoading}
                                Notes={Notes}
                                setNotes={setNotes}
                                noteStructureRef={noteStructureRef}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                              ></PatientPersonalHistory>
                            </div>
                          )}
                          {activeTab === 18 && (
                            <div className="position-relative">
                              <Addendum patientID={patientID} noteID={noteID} />
                            </div>
                          )}
                          {activeTab === 4 && (
                            <div className="position-relative">
                              <PatientInternalNotes noteStructureRef={noteStructureRef} saveTreatsShell={saveTreatsShell} patientID={patientID} loading={loading} setLoading={setLoading} Notes={Notes} setNotes={setNotes}></PatientInternalNotes>
                            </div>
                          )}
                          {activeTab === 28 && (
                            <div className={`  ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} px-2  `}>
                              <ProviderHR
                                getPatientHistory={getPatientHistory}
                                handleAddHistoryToggle={handleAddHistoryToggle}
                                showDataIfNoteIsFollowUp={noteID && noteID >= 0 ? true : false}
                                setHistories={setHistories}
                                AddHistoryToggle={AddHistoryToggle}
                                setAddHistoryToggle={setAddHistoryToggle}
                                saveTreatsShell={saveTreatsShell}
                                loading={loading}
                                setLoading={setLoading}
                                allergiesList={allergiesList}
                                setAllergiesList={setAllergiesList}
                                hospitalRecords={allHistory}
                                personalHistory={histories}
                                setPersonalHistory={setHistories}
                                noteStructureRef={noteStructureRef}
                                patientID={patientID}
                                Notes={Notes}
                                setNotes={setNotes}
                              />
                            </div>
                          )}
                          {activeTab === 24 && (
                            <div className={`  ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} px-2  `}>
                              <ProviderPatientHistoryTest
                                patientTreatments={patientTreatments}
                                noteID={noteID}
                                showAllNotes={true}
                                getPatientHistory={getPatientHistory}
                                viewPatientDetail={patientData}
                                handleAddHistoryToggle={handleAddHistoryToggle}
                                showDataIfNoteIsFollowUp={noteID && noteID >= 0 ? true : false}
                                setHistories={setHistories}
                                AddHistoryToggle={AddHistoryToggle}
                                setAddHistoryToggle={setAddHistoryToggle}
                                saveTreatsShell={saveTreatsShell}
                                loading={loading}
                                setLoading={setLoading}
                                allergiesList={allergiesList}
                                setAllergiesList={setAllergiesList}
                                hospitalRecords={allHistory}
                                personalHistory={histories}
                                setPersonalHistory={setHistories}
                                noteStructureRef={noteStructureRef}
                                patientID={patientID}
                                Notes={Notes}
                                setNotes={setNotes}
                                patientDBData={patientDBData}
                                loggedUserProvider={loggedUserProvider}
                                setPatientDBData={setPatientDBData}
                              />
                            </div>
                          )}
                          {activeTab === 5 && (
                            <div className="position-relative">
                              <PatientVitals noteStructureRef={noteStructureRef} saveTreatsShell={saveTreatsShell} patientID={patientID} loading={loading} setLoading={setLoading} vitalsList={vitalsList} setVitalsList={setVitalsList}></PatientVitals>
                            </div>
                          )}
                          {activeTab === 29 && (
                            <div className={`position-relative ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} px-2 overflow-hidden`}>
                              <ProviderObjectivedatatest
                                showAllNotes={true}
                                patientTreatments={patientTreatments}
                                viewPatientDetail={patientData}
                                vitalsList={vitalsList}
                                setVitalsList={setVitalsList}
                                saveTreatsShell={saveTreatsShell}
                                loggedUserProvider={loggedUserProvider}
                                masterMedications={masterMedications}
                                noteID={noteID}
                                setNewmedsAdded={setNewmedsAdded}
                                patientID={patientID}
                                fetchMedications={fetchMedications}
                                loading={loading}
                                setLoading={setLoading}
                                setNewImagingAdded={setNewImagingAdded}
                                GetPatientImagings={GetPatientImagings}
                                setRender={setRender}
                                setImagingList={setImagingList}
                                imagingTypeList={imagingTypeList}
                                imagingList={imagingList}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                noteStructureRef={noteStructureRef}
                                showComment={showComment}
                                setShowComment={setShowComment}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                                medicationList={medicationList}
                                setMedicationList={setMedicationList}
                                appoinmentDate={appoinmentDate}
                                fetchPatientLabs={fetchPatientLabs}
                                setDataId={setDataId}
                                setNewLabsAdded={setNewLabsAdded}
                                allLabs={allLabs}
                                setAllLabs={setAllLabs}
                                patientDBData={patientDBData}
                                setPatientDBData={setPatientDBData}
                              ></ProviderObjectivedatatest>
                            </div>
                          )}
                          {activeTab === 30 && (
                            <div className={`position-relative ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} px-2 overflow-hidden`}>
                              <ProviderHpiTabTest
                                hpiAdded={hpiAdded}
                                setHpiAdded={setHpiAdded}
                                vitalsList={vitalsList}
                                setVitalsList={setVitalsList}
                                deletePatientDiagnosis={deletePatientDiagnosis}
                                setPatientDiagnosis={setPatientDiagnosis}
                                saveTreatsShell={saveTreatsShell}
                                noteID={noteID}
                                setNewmedsAdded={setNewmedsAdded}
                                patientID={patientID}
                                fetchMedications={fetchMedications}
                                loading={loading}
                                setLoading={setLoading}
                                setNewImagingAdded={setNewImagingAdded}
                                GetPatientImagings={GetPatientImagings}
                                setRender={setRender}
                                setImagingList={setImagingList}
                                imagingTypeList={imagingTypeList}
                                imagingList={imagingList}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                noteStructureRef={noteStructureRef}
                                showComment={showComment}
                                setShowComment={setShowComment}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                                medicationList={medicationList}
                                setMedicationList={setMedicationList}
                                appoinmentDate={appoinmentDate}
                                fetchPatientLabs={fetchPatientLabs}
                                setDataId={setDataId}
                                setNewLabsAdded={setNewLabsAdded}
                                allLabs={allLabs}
                                patientData={patientData}
                                isAllotedToProvider={isAllotedToProvider}
                                patientDiagnosis={patientDiagnosis}
                                showDataIfNoteIsFollowUp={noteID && noteID >= 0 ? true : false}
                                setAllLabs={setAllLabs}
                                loggedUserProvider={loggedUserProvider}
                              ></ProviderHpiTabTest>
                            </div>
                          )}
                          {activeTab === 31 && (
                            <div className={`position-relative ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} px-2 overflow-hidden`}>
                              <ProviderIncidentTabTest setAddedNewIncident={setAddedNewIncident} saveTreatsShell={saveTreatsShell} isAllotedToProvider={isAllotedToProvider} patientID={patientID} showDataIfNoteIsFollowUp={noteID && noteID >= 0 ? true : false} noteStructureRef={noteStructureRef} />
                            </div>
                          )}
                          {activeTab === 32 && (
                            <div className={`position-relative ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} px-2 overflow-hidden`}>
                              <ProviderRosTabTest rosAdded={rosAdded} setRosAdded={setRosAdded} patientID={patientID} isAllotedToProvider={isAllotedToProvider} noteStructureRef={noteStructureRef} />
                            </div>
                          )}

                          {activeTab === 33 && (
                            <div className={`position-relative ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} px-2 overflow-hidden`}>
                              <ProviderPhysicalExaminationTabTest
                                peAdded={peAdded}
                                setPEAdded={setPEAdded}
                                noteID={noteID}
                                patientID={patientID}
                                showDataIfNoteIsFollowUp={noteID && noteID >= 0 ? true : false}
                                patientDiagnosis={patientDiagnosis}
                                isAllotedToProvider={isAllotedToProvider}
                                noteStructureRef={noteStructureRef}
                                patientDBData={patientDBData}
                                setPatientDBData={setPatientDBData}
                              />
                            </div>
                          )}

                          {activeTab === 8 && (
                            <div className={`position-relative ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} px-2 overflow-hidden`}>
                              <ProviderPatientMedication
                                saveTreatsShell={saveTreatsShell}
                                noteID={noteID}
                                setNewmedsAdded={setNewmedsAdded}
                                patientID={patientID}
                                patientName={[patientData?.FirstName, patientData?.MiddleName, patientData?.LastName].filter(Boolean).join(' ')}
                                facilityName={patientData?.FacilityName || ''}
                                roomNumber={patientData?.Room || ''}
                                fetchMedications={fetchMedications}
                                loading={loading}
                                setLoading={setLoading}
                                medicationList={medicationList}
                                setMedicationList={setMedicationList}
                                noteStructureRef={noteStructureRef}
                                appoinmentDate={appoinmentDate}
                              ></ProviderPatientMedication>
                            </div>
                          )}
                          {activeTab === 13 && (
                            <div className="position-relative">
                              <PatientAllergies noteStructureRef={noteStructureRef} saveTreatsShell={saveTreatsShell} patientID={patientID} loading={loading} setLoading={setLoading} allergiesList={allergiesList} setAllergiesList={setAllergiesList}></PatientAllergies>
                            </div>
                          )}
                          {activeTab === 16 && (
                            <div className="position-relative px-2">
                              <Reports patientID={patientID} viewPatientDetail={patientData} patientTreatments={patientTreatments} noteID={noteID} showAllNotes={true} />
                            </div>
                          )}
                          {activeTab === 6 && (
                            <div className="position-relative px-2">
                              <ProvuderPatientImaging
                                saveTreatsShell={saveTreatsShell}
                                setNewImagingAdded={setNewImagingAdded}
                                GetPatientImagings={GetPatientImagings}
                                setRender={setRender}
                                patientID={patientID}
                                setImagingList={setImagingList}
                                imagingTypeList={imagingTypeList}
                                loading={loading}
                                setLoading={setLoading}
                                imagingList={imagingList}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                noteStructureRef={noteStructureRef}
                                showComment={showComment}
                                setShowComment={setShowComment}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                              ></ProvuderPatientImaging>
                            </div>
                          )}
                          {activeTab === 26 && (
                            <div className="position-relative">
                              <ProviderEducation />
                            </div>
                          )}
                          {activeTab === 27 && (
                            <div className="position-relative">
                              <ProviderSuperbill
                                getAppointmentForThisPatientScheduled={getAppointmentForThisPatientScheduled}
                                getSuperbillForthisnote={getSuperbillForthisnote}
                                allAppointmentRawData={allAppointmentRawData}
                                setIsSuperbillUpdateOrSubmitted={setIsSuperbillUpdateOrSubmitted}
                                viewPatientDetail={patientData}
                                patientTreatments={patientTreatments}
                                noteID={noteID}
                                patientDiagnosis={patientDiagnosis}
                                diagnosisCode={diagnosisCode}
                                patientDBData={patientDBData}
                                setPatientDBData={setPatientDBData}
                              />
                            </div>
                          )}
                          {activeTab === 9 && (
                            <div className="position-relative px-2">
                              <ProviderOrderTest
                                setPastOrders={setCurrentOrder}
                                fetchOrdersAgain={fetchCurrentOrders}
                                patientID={patientID}
                                noteID={noteID}
                                orders={currentOrder}
                                patientTreatments={patientTreatments}
                                allOrders={allOrders}
                                setAllOrders={setAllOrders}
                                patientDBData={patientDBData}
                                setPatientDBData={setPatientDBData}
                              />
                            </div>
                          )}
                          {activeTab === 15 && <div className="position-relative">{/* <PatientOrder patientID={patientID} fetchOrders={fetchOrders} patientOrders={patientOrders} setPatientOrders={setPatientOrders} /> */}</div>}
                          {activeTab === 22 && (
                            <div className={`position-relative ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} px-2 overflow-hidden`}>
                              <ProviderPatientTreatmentShellTest
                                setActiveTabPatientInfo={setActiveTab}
                                addendumData={addendum}
                                showDataIfNoteIsFollowUp={noteID && noteID >= 0 ? true : false}
                                fetchPatientLabs={fetchPatientLabs}
                                vitalsList={vitalsList}
                                setVitalsList={setVitalsList}
                                isAllotedToProvider={isAllotedToProvider}
                                saveTreatsShell={saveTreatsShell}
                                setDataId={setDataId}
                                statusPatientNote={noteStatus || ''}
                                showComment={showComment}
                                targetRef={targetRef}
                                selectedRisks={selectedRisks}
                                setSelectedRisks={setSelectedRisks}
                                selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                                setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                                toPDF={toPDF}
                                masterMedications={masterMedications}
                                setMasterMedications={setMasterMedications}
                                GetMasterMedications={GetMasterMedications}
                                noteStructureRef={noteStructureRef}
                                hospitalRecords={allHistory}
                                setHospitalRecords={setAllHistory}
                                medication={medicationList}
                                setMedication={setMedicationList}
                                patientID={patientID}
                                diagnosisAddedPinger={diagnosisAddedPinger}
                                allergies={allergiesList}
                                setAllergies={setAllergiesList}
                                MasterDiagnosisData={MasterDiagnosisData}
                                imaging={imagingList}
                                setImaging={setImagingList}
                                newImagingAdded={newImagingAdded}
                                newLabsAdded={newLabsAdded}
                                newmedsAdded={newmedsAdded}
                                activeTab={historyPersonalHistoryActiveTab}
                                setActiveTab={setHistoryPersonalHistoryActiveTab}
                                patientData={patientData}
                                patientSidebarActiveTab={activeTab}
                                diagnosisCode={diagnosisCode}
                                patientTreatments={patientTreatments}
                                setNewLabsAdded={setNewLabsAdded}
                                setAllLabs={setAllLabs}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                                personalHistory={histories}
                                setPersonalHistory={setHistories}
                                allLabs={allLabs}
                                setReRender={setReRender}
                                patientDiagnosis={patientDiagnosis}
                                loading={loading}
                                imagingTypeList={imagingTypeList}
                                setLoading={setLoading}
                                imagingList={imagingList}
                                setImagingList={setImagingList}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                noteID={noteID}
                                editPatientDiagnosis={editPatientDiagnosis}
                                deletePatientDiagnosis={deletePatientDiagnosis}
                                updateNoteStructure={updateNoteStructure}
                                patientDBData={patientDBData}
                                setPatientDBData={setPatientDBData}
                                loggedUserProvider={loggedUserProvider}
                                changesInTreatmentShell={changesInTreatmentShell}
                                setChangesInTreatmentShell={setChangesInTreatmentShell}
                              ></ProviderPatientTreatmentShellTest>
                            </div>
                          )}
                          {activeTab === 10 && (
                            <div className={`position-relative ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} px-2 overflow-hidden`}>
                              <ProviderFinalNote
                                addendumData={addendum}
                                setActiveTabPatientInfo={setActiveTab}
                                fetchPatientLabs={fetchPatientLabs}
                                vitalsList={vitalsList}
                                setVitalsList={setVitalsList}
                                isAllotedToProvider={isAllotedToProvider}
                                saveTreatsShell={saveTreatsShell}
                                setDataId={setDataId}
                                statusPatientNote={noteStatus || ''}
                                showComment={showComment}
                                targetRef={targetRef}
                                selectedRisks={selectedRisks}
                                setSelectedRisks={setSelectedRisks}
                                selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                                setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                                toPDF={toPDF}
                                masterMedications={masterMedications}
                                setMasterMedications={setMasterMedications}
                                GetMasterMedications={GetMasterMedications}
                                noteStructureRef={noteStructureRef}
                                hospitalRecords={allHistory}
                                setHospitalRecords={setAllHistory}
                                medication={medicationList}
                                setMedication={setMedicationList}
                                patientID={patientID}
                                diagnosisAddedPinger={diagnosisAddedPinger}
                                allergies={allergiesList}
                                setAllergies={setAllergiesList}
                                MasterDiagnosisData={MasterDiagnosisData}
                                imaging={imagingList}
                                setImaging={setImagingList}
                                newImagingAdded={newImagingAdded}
                                newLabsAdded={newLabsAdded}
                                newmedsAdded={newmedsAdded}
                                activeTab={historyPersonalHistoryActiveTab}
                                setActiveTab={setHistoryPersonalHistoryActiveTab}
                                patientData={patientData}
                                patientSidebarActiveTab={activeTab}
                                diagnosisCode={diagnosisCode}
                                patientTreatments={patientTreatments}
                                setNewLabsAdded={setNewLabsAdded}
                                setAllLabs={setAllLabs}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                                personalHistory={histories}
                                setPersonalHistory={setHistories}
                                allLabs={allLabs}
                                setReRender={setReRender}
                                patientDiagnosis={patientDiagnosis}
                                loading={loading}
                                imagingTypeList={imagingTypeList}
                                setLoading={setLoading}
                                imagingList={imagingList}
                                setImagingList={setImagingList}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                noteID={noteID}
                                editPatientDiagnosis={editPatientDiagnosis}
                                deletePatientDiagnosis={deletePatientDiagnosis}
                                updateNoteStructure={updateNoteStructure}
                              ></ProviderFinalNote>
                            </div>
                          )}
                          {activeTab === 7 && (
                            <div className="position-relative px-2 mt-3">
                              <PatientProviderlabs
                                saveTreatsShell={saveTreatsShell}
                                fetchPatientLabs={fetchPatientLabs}
                                setDataId={setDataId}
                                setNewLabsAdded={setNewLabsAdded}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                patientID={patientID}
                                allLabs={allLabs}
                                setAllLabs={setAllLabs}
                                loading={loading}
                                setLoading={setLoading}
                                noteStructureRef={noteStructureRef}
                                showComment={showComment}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                              ></PatientProviderlabs>
                            </div>
                          )}
                          {activeTab === 20 && (
                            <div className="position-relative">
                              <PatientPastNote viewPatientDetail={patientData} patientTreatments={patientTreatments} noteID={noteID} />
                            </div>
                          )}

                          {/* {activeTab === 17 && (
                            <div className="position-relative">
                              <HPIQuestions diagnosis={patientDiagnosis} />
                            </div>
                          )} */}
                        </div>
                      </CCardBody>
                    </CCard>
                  </CRow>
                </CCol>
                <CModal
                  size="xl"
                  visible={modalVisible}
                  backdrop="static"
                  keyboard={false}
                  onClose={() => {
                    ;(setModalVisible(false), setIsAckChecked(false))
                  }}
                >
                  <CModalHeader
                    style={{
                      backgroundColor: '#282828',
                      borderBottom: '1px solid gray',
                      color: 'white',
                      display: 'flex',
                      justifyContent: 'center',
                      borderRadius: '10px 10px 0 0',
                    }}
                    onClose={() => {
                      ;(setModalVisible(false), setIsAckChecked(false))
                    }}
                  >
                    <CModalTitle style={{ color: 'white', width: '100%' }}>Note Details</CModalTitle>
                  </CModalHeader>
                  <CModalBody
                    style={{
                      backgroundColor: '#282828',
                      color: 'white',
                    }}
                  >
                    <div style={{ display: 'flex' }}>
                      {/* Left Side: Main PatientNoteViewInModal */}
                      <div style={{ flex: 1, paddingRight: '10px', width: '50%' }}>
                        <div style={{ height: '70vh', overflowY: 'auto' }}>
                          <ProviderLsPatientNoteViewTest
                            patientID={patientID}
                            statusPatientNoteWasFollowUp={noteStatus && noteStatus === 'Follow Up' ? true : false}
                            showHrsInTreatment={true}
                            setDataId={setDataId}
                            showTreatmentAsAccordion={true}
                            showComment={showComment}
                            submitNotes={submitNotes}
                            setModalVisible={setModalVisible}
                            patientDBData={patientDBData}
                            setPatientDBData={setPatientDBData}
                            formData={patientData}
                            diagnosis={diagnosisData}
                            diagnosisCode={diagnosisCode}
                            noteStructureRef={noteStructureRef}
                            selectedRisks={selectedRisks}
                            setSelectedRisks={setSelectedRisks}
                            selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                            setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                            hospitalRecords={allHistory}
                            setHospitalRecords={setAllHistory}
                            medication={medicationList}
                            setMedication={setMedicationList}
                            patientTreatments={patientTreatments}
                            newImagingAdded={newImagingAdded}
                            newLabsAdded={newLabsAdded}
                            newmedsAdded={newmedsAdded}
                            diagnosisAddedPinger={diagnosisAddedPinger}
                            allergies={allergiesList}
                            setAllergies={setAllergiesList}
                            patientDiagnosis={patientDiagnosis}
                            MasterDiagnosisData={MasterDiagnosisData}
                            imagingTypeList={imagingTypeList}
                            imaging={imagingList}
                            setImaging={setImagingList}
                            activeTab={historyPersonalHistoryActiveTab}
                            setActiveTab={setHistoryPersonalHistoryActiveTab}
                            patientData={patientData}
                            patientSidebarActiveTab={activeTab}
                            personalHistory={histories}
                            setPersonalHistory={setHistories}
                            allLabs={allLabs}
                            noteID={noteID}
                            showMedicationLikeApp={true}
                            showToolbar={false}
                            addendumData={addendum}
                            showDataIfNoteIsFollowUp={noteID && noteID >= 0 ? true : false}
                          ></ProviderLsPatientNoteViewTest>
                        </div>
                      </div>

                      {/* Right Side: Signature & Acknowledgment */}
                      <div style={{ flex: 1, paddingLeft: '10px', width: '50%' }}>
                        <b style={{ marginTop: '10px' }}>Add your name below:</b>
                        <CFormTextarea
                          style={{
                            width: '100%',
                            height: '150px',
                            padding: '10px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            backgroundColor: '#191919',
                            resize: 'none',
                            marginTop: '5px',
                            color: 'white',
                          }}
                          placeholder="Enter your name..."
                        />
                        <div></div>
                        <div style={{ marginTop: '10px' }}>
                          <CFormCheck id="ack" label="I acknowledge that the information provided is accurate, complete, and has been reviewed and verified to the best of my knowledge." checked={isAckChecked} onChange={(e) => setIsAckChecked(e.target.checked)} className="mt-2" />
                        </div>
                        <div className="" style={{ height: '40vh', overflow: 'auto' }}>
                          <ShowAddedOrders patientID={patientID} noteID={noteID} patientDBData={patientDBData} />
                        </div>
                      </div>
                    </div>
                  </CModalBody>

                  <CModalFooter
                    style={{
                      backgroundColor: '#282828',
                      borderTop: '1px solid gray',
                      display: 'flex',
                      justifyContent: 'end',
                      gap: '10px',
                    }}
                  >
                    <CButton
                      color="primary"
                      onClick={() => {
                        submitNotes({
                          signatureInfo: {
                            signedTime: new Date().toISOString(),
                            signedDate: new Date().toLocaleDateString('en-US'),
                            signedTimeUs: new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
                          },
                        })
                      }}
                      disabled={!isAckChecked}
                    >
                      {signLoaderModel ? (
                        <>
                          <CSpinner size="sm" className="me-2" /> Saving...
                        </>
                      ) : (
                        'Sign'
                      )}
                    </CButton>
                    <CButton
                      color="secondary"
                      variant="outline"
                      onClick={() => {
                        ;(setModalVisible(false), setIsAckChecked(false))
                      }}
                    >
                      Close
                    </CButton>
                  </CModalFooter>
                </CModal>

                {/* <CCol xs={3} className='custom-scrollbar-container border  bg-white  ' style={{
                    overflowX: "hidden",
                    overflowY: "auto",
                    borderRadius: '10px',
                    // paddingRight: '8px',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#c0c0c0 transparent',
                    height: '90vh'
                  }}>
                    <div className=' '>
                      <PatientFinalNote
                        statusPatientNote={noteStatus && noteStatus === "Follow Up" ? true : false}
                        diagnosisCode={diagnosisCode}
                        noteStructureRef={noteStructureRef}
                        selectedRisks={selectedRisks} setSelectedRisks={setSelectedRisks}
                        selectedDifferentialDiagnosis={selectedDifferentialDiagnosis} setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                        hospitalRecords={allHistory} setHospitalRecords={setAllHistory}
                        medication={medicationList} setMedication={setMedicationList}
                        patientID={patientID}
                        patientTreatments={patientTreatments}
                        newImagingAdded={newImagingAdded} newLabsAdded={newLabsAdded} newmedsAdded={newmedsAdded}
                        diagnosisAddedPinger={diagnosisAddedPinger}
                        allergies={allergiesList} setAllergies={setAllergiesList}
                        patientDiagnosis={patientDiagnosis}
                        MasterDiagnosisData={MasterDiagnosisData}
                        imagingTypeList={imagingTypeList}
                        imaging={imagingList} setImaging={setImagingList}
                        activeTab={historyPersonalHistoryActiveTab} setActiveTab={setHistoryPersonalHistoryActiveTab}
                        patientData={patientData} patientSidebarActiveTab={activeTab}
                        personalHistory={histories} setPersonalHistory={setHistories}
                        allLabs={allLabs}
                        noteShow={true} noteID={noteID}
                      ></PatientFinalNote>
                     
                    </div>
                  </CCol> */}
              </div>

              <div>
                <CModal size="xl" backdrop="static" visible={noteView} onClose={() => setNoteView(false)}>
                  <CModalHeader
                    style={{
                      backgroundColor: '#282828',
                      borderBottom: '1px solid gray',
                      color: 'white',
                      display: 'flex',
                      justifyContent: 'center',
                      borderRadius: '10px 10px 0 0',
                    }}
                    className="dark-note-modal"
                    onClose={() => setNoteView(false)}
                  >
                    <CModalTitle className="text-center w-100 text-white">Patient Note</CModalTitle>
                  </CModalHeader>
                  <CModalBody
                    style={{
                      height: '80vh',
                      overflowY: 'auto',
                      background: '#282828', // optional: adds scroll if content exceeds height
                    }}
                  >
                    <ProviderLsSuperBillComponent
                      patientID={patientID}
                      statusPatientNote={noteStatus || ''}
                      showCreateTaskInOrder={false}
                      showHrsInTreatment={true}
                      setDataId={setDataId}
                      showTreatmentAsAccordion={true}
                      showComment={showComment}
                      submitNotes={submitNotes}
                      setModalVisible={setModalVisible}
                      formData={patientData}
                      diagnosis={diagnosisData}
                      diagnosisCode={diagnosisCode}
                      noteStructureRef={noteStructureRef}
                      selectedRisks={selectedRisks}
                      setSelectedRisks={setSelectedRisks}
                      selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                      setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                      hospitalRecords={allHistory}
                      setHospitalRecords={setAllHistory}
                      medication={medicationList}
                      setMedication={setMedicationList}
                      patientTreatments={patientTreatments}
                      newImagingAdded={newImagingAdded}
                      newLabsAdded={newLabsAdded}
                      newmedsAdded={newmedsAdded}
                      diagnosisAddedPinger={diagnosisAddedPinger}
                      allergies={allergiesList}
                      setAllergies={setAllergiesList}
                      patientDiagnosis={patientDiagnosis}
                      MasterDiagnosisData={MasterDiagnosisData}
                      imagingTypeList={imagingTypeList}
                      imaging={imagingList}
                      setImaging={setImagingList}
                      activeTab={historyPersonalHistoryActiveTab}
                      setActiveTab={setHistoryPersonalHistoryActiveTab}
                      patientData={patientData}
                      patientSidebarActiveTab={activeTab}
                      personalHistory={histories}
                      setPersonalHistory={setHistories}
                      allLabs={allLabs}
                      noteID={noteID}
                      showMedicationLikeApp={true}
                      patientDBData={patientDBData}
                    />
                  </CModalBody>
                </CModal>
                <AddDiagnosisModal
                  showOnlyNoteDiagnosis={showOnlyNoteDiagnosis}
                  setDiagnosisAddedPinger={setDiagnosisAddedPinger}
                  addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                  saveDiagnosisData={saveDiagnosisData}
                  patientData={patientData}
                  setAddDiagnosisModalVisible={setAddDiagnosisModalVisible}
                  addDiagnosisModalVisible={addDiagnosisModalVisible}
                  handleToggleAddDiagnosis={() => {
                    setAddDiagnosisModalVisible((p) => !p)
                  }}
                  patientID={patientID}
                  getPatientDiagnosis={getPatientDiagnosis}
                  updatePatientDiagnosis={updatePatientDiagnosis}
                  patientDiagnosis={patientDiagnosis}
                  setPatientData={setPatientData}
                  loggedUserProvider={loggedUserProvider}
                />

                <CModal size="md" backdrop="static" visible={showSaveModel} onClose={() => setShowSaveModel(false)}>
                  <CModalHeader>
                    <CModalTitle>Warning</CModalTitle>
                  </CModalHeader>
                  <CModalBody>
                    <p>This note has already been submitted. Are you sure you want to save it as a draft?</p>
                  </CModalBody>

                  <CModalFooter>
                    <CButton
                      onClick={() => {
                        ;(saveTreatsShell(), setShowSaveModel(false))
                      }}
                      variant="outline"
                      color="warning"
                    >
                      Save as Draft
                    </CButton>
                    <CButton
                      onClick={() => {
                        setShowSaveModel(false)
                      }}
                      className=" "
                      variant="outline"
                      color="secondary"
                    >
                      {' '}
                      Cancel
                    </CButton>
                  </CModalFooter>
                </CModal>

                <CModal size="md" backdrop="static" visible={signModel} onClose={() => setSignModel(false)}>
                  <CModalHeader>
                    <CModalTitle>Warning</CModalTitle>
                  </CModalHeader>
                  <CModalBody>
                    <p>This note has already been Signed. Are you sure you want to save it as draft?</p>
                  </CModalBody>

                  <CModalFooter>
                    <CButton
                      onClick={() => {
                        ;(submitNotes(), setSignModel(false))
                      }}
                      variant="outline"
                      color="warning"
                    >
                      Save as Draft
                    </CButton>
                    <CButton
                      onClick={() => {
                        setSignModel(false)
                      }}
                      className=" "
                      variant="outline"
                      color="secondary"
                    >
                      {' '}
                      Cancel
                    </CButton>
                  </CModalFooter>
                </CModal>
              </div>
              <CModal size="lg" backdrop="static" visible={showSuperBill} onClose={() => setShowSuperBill(false)}>
                <CModalHeader>
                  <CModalTitle>Super Bill</CModalTitle>
                </CModalHeader>
                <CModalBody>
                  <ProviderSuperbill viewPatientDetail={patientData} patientTreatments={patientTreatments} noteID={noteID} patientDiagnosis={patientDiagnosis} diagnosisCode={diagnosisCode} showInModel={true} setShowSuperBill={setShowSuperBill} />
                </CModalBody>
              </CModal>

              {/* Edit patient */}
              <CModal size="lg" visible={editModalVisible} onClose={() => setEditModalVisible(false)}>
                <CModalHeader
                  style={{
                    backgroundColor: '#191919',
                    borderBottom: '1px solid gray',
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'center',
                    borderRadius: '10px 10px 0 0',
                  }}
                >
                  <CModalTitle style={{ color: 'white', width: '100%', textAlign: 'center' }}>Edit Patient</CModalTitle>
                </CModalHeader>

                <CModalBody
                  style={{
                    backgroundColor: '#191919',
                    color: 'white',
                  }}
                >
                  <div className="m-3">
                    <AddProviderPatientForm formData={childformData} setFormData={setChildFormData} facility={facility} setFacility={setFacility} />
                  </div>
                </CModalBody>
                <CModalFooter
                  style={{
                    backgroundColor: '#191919',
                    borderTop: '1px solid gray',
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                    padding: '10px',
                    borderRadius: '0 0 10px 10px',
                  }}
                >
                  <CButton
                    style={{
                      backgroundColor: '#333',
                      border: '1px solid gray',
                      color: 'white',
                      borderRadius: '6px',
                      padding: '8px 20px',
                    }}
                    variant="outlined"
                    onClick={() => {
                      resetStates()
                    }}
                  >
                    Close
                  </CButton>
                  <CButton
                    style={{
                      backgroundColor: '#4363F2',
                      border: 'none',
                      color: 'white',
                      borderRadius: '6px',
                      padding: '8px 20px',
                    }}
                    disabled={creatingPatientLoader}
                    variant="contained"
                    onClick={() => handleEditPatinetSubmit()}
                  >
                    {creatingPatientLoader ? <CircularProgress className="text-white p-1" size={20} /> : 'Update'}
                  </CButton>
                </CModalFooter>
              </CModal>

              {showOrderPopUpYN && (
                <CModal size="lg" backdrop="static" visible={showOrderPopUp} onClose={() => setShowOrderPopUp(false)}>
                  <CModalHeader
                    style={{
                      backgroundColor: '#282828',
                      borderBottom: '1px solid gray',
                      color: 'white',
                      display: 'flex',
                      justifyContent: 'center',
                      borderRadius: '10px 10px 0 0',
                    }}
                  >
                    <CModalTitle style={{ color: 'white' }}>Previous Order</CModalTitle>
                  </CModalHeader>
                  <CModalBody className="" style={{ maxHeight: '500px', overflow: 'auto', backgroundColor: '#282828', color: 'white' }}>
                    <ProviderPastOrder patientID={patientID} noteID={noteID} headerShow={false} orders={pastOrders} />
                  </CModalBody>

                  <CModalFooter
                    className=" "
                    style={{
                      backgroundColor: '#282828',
                      borderTop: '1px solid gray',
                      display: 'flex',
                      justifyContent: 'end',
                      gap: '10px',
                      paddingTop: '10px',
                    }}
                  >
                    <CButton onClick={() => handleOrderFlag()}>Verified</CButton>
                    <CButton
                      onClick={() => {
                        setShowOrderPopUp(false)
                      }}
                      className=" "
                      variant="outline"
                      color="secondary"
                    >
                      {' '}
                      Cancel
                    </CButton>
                  </CModalFooter>
                </CModal>
              )}
            </CRow>
          )}
          {showNoteView && patientTreatments && (
            <>
              <ProviderPatientNoteViewInModal
                patientID={patientID}
                statusPatientNoteWasFollowUp={noteStatus && noteStatus === 'Follow Up' ? true : false}
                showHrsInTreatment={true}
                setDataId={setDataId}
                showTreatmentAsAccordion={true}
                showComment={showComment}
                submitNotes={submitNotes}
                setModalVisible={setModalVisible}
                formData={patientData}
                diagnosis={diagnosisData}
                diagnosisCode={diagnosisCode}
                noteStructureRef={noteStructureRef}
                selectedRisks={selectedRisks}
                setSelectedRisks={setSelectedRisks}
                selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                hospitalRecords={allHistory}
                setHospitalRecords={setAllHistory}
                medication={medicationList}
                setMedication={setMedicationList}
                patientTreatments={patientTreatments}
                newImagingAdded={newImagingAdded}
                newLabsAdded={newLabsAdded}
                newmedsAdded={newmedsAdded}
                diagnosisAddedPinger={diagnosisAddedPinger}
                allergies={allergiesList}
                setAllergies={setAllergiesList}
                patientDiagnosis={patientDiagnosis}
                MasterDiagnosisData={MasterDiagnosisData}
                imagingTypeList={imagingTypeList}
                imaging={imagingList}
                setImaging={setImagingList}
                activeTab={historyPersonalHistoryActiveTab}
                setActiveTab={setHistoryPersonalHistoryActiveTab}
                patientData={patientData}
                patientSidebarActiveTab={activeTab}
                personalHistory={histories}
                setPersonalHistory={setHistories}
                allLabs={allLabs}
                noteID={noteID}
                showMedicationLikeApp={true}
                showToolbar={false}
                addendumData={addendum}
                showDataIfNoteIsFollowUp={noteID && noteID >= 0 ? true : false}
              ></ProviderPatientNoteViewInModal>
            </>
          )}
        </div>
      )}
    </>
  )
}
export default PatientInfoTodaysAppointmentsTest
